<template>
  <div class="docViewHolder" :style="cssVars" v-resize="autoCollapseSidePanels">
    <v-navigation-drawer
      v-if="admin || show_lhs_expand"
      class="docSectionHolderLeft"
      v-model="lhDrawer.show"
      absolute
      left
      :mobile-breakpoint="0"
      :temporary="lhDrawer.temporary"
    >
      <div class="docSectionHolderLeftActions" v-if="!admin">
        <v-icon
          :title="lhDrawer.show ? 'Show Navigation' : 'Hide Navigation'"
          color="#a1a4a9"
          @click="lhDrawer.show = !lhDrawer.show"
          >{{ lhDrawer.show ? 'mdi-chevron-left-circle-outline' : 'mdi-chevron-right-circle-outline' }}</v-icon
        >
      </div>
      <ViewSection
        v-show="leftPanel === 'sections'"
        ref="viewDisplay"
        :templateView="currentView"
        @changeSection="loadSectionContent"
        @addSubSection="addSubSection"
        @editSection="editSectionDefinition"
        :adminMode="admin"
        @addSection="addSection"
        @editSectionOrder="editSectionOrder"
        @editPermissions="editPermissions"
      />
    </v-navigation-drawer>

    <div class="docSectionHolderLeftActionsTemp" v-if="!admin && show_lhs_expand &&!lhDrawer.show">
      <v-icon
        :title="lhDrawer.show ? 'Show Navigation' : 'Hide Navigation'"
        color="#a1a4a9"
        @click="lhDrawer.show = !lhDrawer.show"
        >{{ lhDrawer.show ? 'mdi-chevron-left-circle-outline' : 'mdi-chevron-right-circle-outline' }}</v-icon
      >
    </div>

    <div class="docHolder">
      <div class="docHolderActionsHeader"
          v-if="saveInProgress">
        <div
          class="doc-view-font small"
          style="position: absolute; right: 20px; top: 5px"
          justify-center
          align-content-center
        >
          <v-icon small color="#377DFF">mdi-autorenew mdi-spin</v-icon>
          <span
            style="
              color: #377dff;
              padding-left: 5px;
              vertical-align: text-bottom;
            "
            >Saving...</span
          >
        </div>
      </div>
      <div class="docHolderTop" v-if="displayHeader">
        <div class="docBanner" v-html="bannerText"></div>
      </div>
      <div
        class="docHolderCenter"
        ref="docContent"
        :id="docHolderCenterElementId(false)"
      >
        <div
          v-if="activeSection && activeSection.view_mode === 'REVIEW'"
          class="ml-3 mr-4 mt-5 mb-6"
        >
          <v-expansion-panels multiple flat>
            <v-expansion-panel
              v-for="(item, i) in currentReviewSection"
              :key="i"
            >
              <v-expansion-panel-header
                style="
                  min-height: 75px;
                  border-top: 1px solid #e3e7f3;
                  border-bottom: 1px solid #e3e7f3;
                  font-family: 'Manrope';
                  font-style: normal;
                  font-weight: 700;
                  font-size: 19px;
                  line-height: 28px;
                "
                :style="{
                  color: item.complete ? '#00B515' : '#3E3E3E',
                }"
                :disable-icon-rotate="item.complete"
              >
                {{ item.section }}

                <template v-slot:actions>
                  <v-icon v-if="!item.complete" color="primary">
                    $expand
                  </v-icon>
                  <v-icon v-if="item.complete" color="#00B515">
                    mdi-check
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content style="padding-top: 30px">
                <ViewParts
                  v-if="item.view_mode === null"
                  :highlightedDocParts="highlightedDocParts"
                  :highlightedDocPartForCommentHover="highlightedDocPartForCommentHover"
                  :highlightedDocPartForCommentFocus="highlightedDocPartForCommentFocus"
                  :data="data"
                  :displayMode="display"
                  :sectionPermission="item.permissions_list"
                  :lockSection="
                    item.permissions_list.editPermissionOverride !== null &&
                    !item.permissions_list.editPermissionOverride
                  "
                  :viewLinkedContent="displayLinkedContent"
                  :parts="
                    item.part_data.filter(
                      (x) =>
                        (x.permissions_list.viewPermissionOverride === null ||
                          x.permissions_list.viewPermissionOverride === true) &&
                        (x.permissions_list.displayPermissionOverride ===
                          null ||
                          x.permissions_list.displayPermissionOverride === true)
                    )
                  "
                  :disableEdit="disablePartEdit"
                  :checkSummary="checkSummary"
                  :adminMode="admin"
                  :partCommentUpdate="partCommentUpdate"
                  :maskedParts="maskedParts"
                  @editStart="editInProgress = true"
                  @editEnd="editInProgress = false"
                  @editPart="editPart"
                  @editPartPermission="editPartPermission"
                  @hierarchyUpdated="hierarchyUpdated"
                  @triggerNotification="triggerNotification"
                  @syncPosition="syncPosition"
                  @suggestionDropEnd="$emit('suggestionDropEnd')"
                  @saveDataCapture="saveDataCapture"
                  @expandChildren="expandChildren"
                  @collapseChildren="collapseChildren"
                />
                <div v-else-if="item.view_mode === 'DATACAPTURE'">
                  <div
                    v-for="(dca, dci) in data.document.state
                      .dataCaptureActionsMain"
                    :key="'dca' + dci"
                  >
                    <DataCaptureLevellingEvaluation
                      v-if="dca.data_capture_method === 'questionnaire' && dca.definition.control_type === 'LEVELLING'"
                      :definition="dca.definition"
                      :action="dca"
                      :docReference="data.document.system_number"
                      @saveAnswer="updateQuestionnaireAnswer"
                      @actionTriggered="doStateAction"
                      @toggleHidden="dca.isDataCaptureHidden = !dca.isDataCaptureHidden">
                    </DataCaptureLevellingEvaluation>
                    <DataCaptureQuestionnaire
                      v-if="dca.data_capture_method === 'questionnaire'"
                      :definition="dca.definition"
                      :action="dca"
                      @saveAnswer="updateQuestionnaireAnswer"
                      @actionTriggered="doStateAction"
                      @toggleHidden="
                        dca.isDataCaptureHidden = !dca.isDataCaptureHidden
                      "
                    />
                    <DataCaptureRequisitions
                      v-else-if="
                        dca.data_capture_method === 'requisition' ||
                        dca.data_capture_method === 'requisition_new'
                      "
                      :action="dca"
                      :isBusy="isLoading"
                      @save="saveDataCapture"
                      @requestEdit="doStateAction"
                      @toggleHidden="
                        dca.isDataCaptureHidden = !dca.isDataCaptureHidden
                      "
                    />
                    <DataCaptureForm
                      v-else-if="dca.data_capture_method === 'form'"
                      :action="dca"
                      :isBusy="isLoading"
                      @save="saveDataCapture"
                      @requestEdit="doStateAction"
                      @toggleHidden="
                        dca.isDataCaptureHidden = !dca.isDataCaptureHidden
                      "
                    />
                    <DataCaptureDocumentRole
                      v-else-if="dca.data_capture_method === 'document_role'"
                      :action="dca"
                      :isBusy="isLoading"
                      @save="saveDataCapture"
                      @requestEdit="doStateAction"
                      @toggleHidden="
                        dca.isDataCaptureHidden = !dca.isDataCaptureHidden
                      "
                    />
                    <AssignReviewGroup
                      v-else-if="dca.data_capture_method === 'review_group'"
                      :docId="document.doc_id"
                      :action="dca"
                      @save="saveDataCapture"
                    >
                    </AssignReviewGroup>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-row style="padding-top: 30px">
            <v-col cols="10"></v-col>
            <v-col cols="2">
              <v-tooltip top v-if="submitAction">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-btn
                      :disabled="
                        currentReviewSection.some((x) => !x.complete) ||
                        isActionDisabled()
                      "
                      style="width: 100%"
                      @click="doSubmitAction"
                      color="primary"
                      >{{ submitAction.name }}</v-btn
                    >
                  </div>
                </template>
                <span>{{ isActionDisabled(true) }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
        <div
          v-else-if="activeSection && activeSection.view_mode === 'DATACAPTURE'"
          class="ml-3 mr-4 mt-5 mb-6"
        >
          <div
            v-for="(dca, dci) in data.document.state.dataCaptureActionsMain"
            :key="'dca' + dci"
          >
            <DataCaptureLevellingEvaluation
              v-if="dca.data_capture_method === 'questionnaire' && dca.definition.control_type === 'LEVELLING'"
              :definition="dca.definition"
              :action="dca"
              :docReference="data.document.system_number"
              @saveAnswer="updateQuestionnaireAnswer"
              @actionTriggered="doStateAction"
              @toggleHidden="dca.isDataCaptureHidden = !dca.isDataCaptureHidden">
            </DataCaptureLevellingEvaluation>
            <DataCaptureQuestionnaire
              v-else-if="dca.data_capture_method === 'questionnaire'"
              :definition="dca.definition"
              :action="dca"
              @saveAnswer="updateQuestionnaireAnswer"
              @actionTriggered="doStateAction"
              @toggleHidden="dca.isDataCaptureHidden = !dca.isDataCaptureHidden"
            />
            <DataCaptureRequisitions
              v-else-if="
                dca.data_capture_method === 'requisition' ||
                dca.data_capture_method === 'requisition_new'
              "
              :action="dca"
              :isBusy="isLoading"
              @save="saveDataCapture"
              @requestEdit="doStateAction"
              @toggleHidden="dca.isDataCaptureHidden = !dca.isDataCaptureHidden"
            />
            <DataCaptureForm
              v-else-if="dca.data_capture_method === 'form'"
              :action="dca"
              :isBusy="isLoading"
              @save="saveDataCapture"
              @requestEdit="doStateAction"
              @toggleHidden="dca.isDataCaptureHidden = !dca.isDataCaptureHidden"
            />
            <AssignReviewGroup
              v-else-if="dca.data_capture_method === 'review_group'"
              :docId="document.doc_id"
              :action="dca"
              @save="saveDataCapture"
            >
            </AssignReviewGroup>
          </div>
        </div>
        <ViewParts
          v-else
          :readOnly="readOnly"
          :data="data"
          :displayMode="display"
          :viewLinkedContent="displayLinkedContent"
          :partTypes="
            sectionParts.filter(
              (x) =>
                (x.permissions_list.viewPermissionOverride === null ||
                  x.permissions_list.viewPermissionOverride === true) &&
                (x.permissions_list.displayPermissionOverride === null ||
                  x.permissions_list.displayPermissionOverride === true)
            )
          "
          :lockSection="
            activeSection &&
            activeSection.permissions_list.editPermissionOverride !== null &&
            !activeSection.permissions_list.editPermissionOverride
          "
          :sectionPermission="sectionPermissionList"
          :disableEdit="disablePartEdit"
          :checkSummary="checkSummary"
          :adminMode="admin"
          :isDragging="dragging"
          :spellcheckEnabled="userSpellCheckEnabled && !isTranslated"
          :spellCheckOnLoad="spellCheckOnLoad"
          :nonSuggestionsList="nonSuggestionsList"
          :partCommentUpdate="partCommentUpdate"
          :maskedParts="maskedParts"
          @editStart="editInProgress = true"
          @editEnd="editInProgress = false"
          @editPart="editPart"
          @editPartPermission="editPartPermission"
          @saveStart="saveStart"
          @saveEnd="saveEnd"
          @showPartHistory="showPartHistory"
          @showDeletedPartHistory="showDeletedPartHistory"
          @updatePart="updatePart"
          @processResults="processResults"
          @changeOrder="reorderParts"
          @deletePart="deletePart"
          @updateContentPart="updateContentPart"
          @openSuggestions="openSuggestions"
          @updateRecentPart="updateRecentPart"
          @resyncItem="resyncItem"
          :highlightedDocParts="highlightedDocParts"
          :highlightedDocPartForCommentHover="highlightedDocPartForCommentHover"
          :highlightedDocPartForCommentFocus="highlightedDocPartForCommentFocus"
          @hierarchyUpdated="hierarchyUpdated"
          @triggerNotification="triggerNotification"
          @syncPosition="syncPosition"
          @suggestionDropEnd="$emit('suggestionDropEnd')"
          @saveDataCapture="saveDataCapture"
          @expandChildren="expandChildren"
          @collapseChildren="collapseChildren"
        />
      </div>
      <div class="docHolderFooter" v-if="display !== 'sidebysidefull'">
        <div>
          <v-btn
            v-if="!navBackHide"
            :disabled="navBackDisabled"
            color="primary"
            class="mt-1 mr-5 userPilotLCBack"
            @click="navSections('Back')"
          >
            <v-icon left>mdi-arrow-left</v-icon>Previous
          </v-btn>
        </div>
        <div style="width: 100%">
          <div class="docBanner" v-if="footerText" v-html="footerText"></div>
        </div>
        <div style="display: inline-flex">
          <v-btn
            v-if="sectionCompleteSub"
            color="success"
            :class="[
              'mt-1',
              'ml-5',
              'userPilotLC' + sectionCompleteLabel?.replace(/\s+/g, ''),
            ]"
            @click="navSections('CompleteAll')"
          >
            {{ sectionCompleteLabel }}
          </v-btn>
          <v-btn
            v-if="!navChangesHide"
            :disabled="navNextDisabled"
            color="success"
            class="mt-1 ml-5 userPilotLCNoChangesRequired"
            @click="navSections('Complete')"
          >
            No Changes Required <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn
            v-if="!navNextHide"
            :disabled="navNextDisabled"
            color="primary"
            class="mt-1 ml-5 userPilotLCNext"
            @click="navSections('Next')"
          >
            Next <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="docSectionHolderRight" v-if="display === 'sidebysidefull'" style="height: 600px;">
      <div v-if="rightPanel === 'all-comments'" class="rightHolderContentMain">
        <DocumentComments
          class="mt-4"
          :document="document"
          all hideHeader :target_doc_part="comment_doc_part"
          heightAdjustment="370px"
          @mouseenter="highlightSectionForCommentHover"
          @mouseleave="highlightSectionForCommentHover(null)"
          @commentclick="scrollToSectionForComment"
          @resetCommentPart="resetSectionForComment"
          @saved="commentSaved"
          @commentResolved="commentResolved"
        >
        </DocumentComments>
      </div>
    </div>
    <div class="docSectionHolderRight" v-if="display !== 'sidebysidefull'">
      <div class="rightHolderNavActions" v-if="!admin && show_rhs_expand" @click="rightPanel === 'hidden' ? toggleRHS('score') : toggleRHS('hidden')">
        <v-icon
          title="Expand"
          v-if="rightPanel === 'hidden'"
        >mdi-chevron-left</v-icon>
        <v-icon
          title="Minimise"
          v-else
        >mdi-chevron-right</v-icon>
      </div>
      <div class="rightHolderNav" v-if="rightPanel !== 'hidden' && showRHSTabs">
        <v-tabs v-model="rightPanelTab" small class="rightHolderTabs" v-if="!admin">
          <v-tabs-slider color="#46A300" height="4px"></v-tabs-slider>
          <v-tab tab-value="score" v-if="showScoring" @click="toggleRHS('score')">
            <span>Score</span>
            <v-progress-circular
              v-if="
                documentIssueDisplay === 'score' ||
                documentIssueDisplay === 'score_header_only'
              "
              :rotate="270"
              :size="35"
              :width="4"
              :value="checkSummary.score"
              :color="checkSummary.scoreColour"
              class="ml-1"
              ><span class="scoreValue">{{ checkSummary.score.toFixed(0) }}</span>
            </v-progress-circular>
          </v-tab>
          <v-tab
            tab-value="contentGen"
            :class="[
              'content-gen-btn',
              { 'content-gen-complete': generateContentDialog.status === 'complete' && !generateContentDialog.completionViewed }
            ]"
            style="padding-left:10px; padding-right:10px"
            v-if="showContentGeneration"
            @click="toggleRHS('contentGen')"
          >
            <span class="content-gen-text">AI Content</span>
            <v-progress-circular
              v-if="generateContentDialog.status === 'processing'"
              indeterminate
              size="12"
              width="2"
              color="primary"
              class="ml-2"
            ></v-progress-circular>
            <v-icon
              v-else-if="generateContentDialog.status === 'complete'"
              color="success"
              class="ml-2 content-gen-check-icon"
            >
              mdi-check-circle
            </v-icon>
          </v-tab>
          <v-tab tab-value="all-comments" v-if="showAllComments && canViewComments" @click="toggleRHS('all-comments')">
            Comments
          </v-tab>
          <v-tab tab-value="suggestions" v-if="showSuggestions" @click="toggleRHS('suggestions')">
            Suggestions
          </v-tab>
          <v-tab tab-value="database" @click="toggleRHS('database')">
            <template v-if="docMatches.highlight">
              Related<br />Content
              <v-chip small color="warning"
                :class="{ 'ml-2': true, 'blinking': docMatches.blinking }"
                close close-icon="mdi-close"
                @click:close="docMatches.highlight = false"
                >
                New
              </v-chip>
            </template>
            <template v-else>
              Related Content
            </template>
          </v-tab>
          
          <v-tab tab-value="skills" v-if="showSkillsPanel" @click="toggleRHS('skills')">
            Skills
          </v-tab>
          <v-tab tab-value="atlas" @click="toggleRHS('atlas')" v-if="utils.atlasFlyoutAvailable($loginState)">
            Atlas
          </v-tab>
        </v-tabs>
        <!-- <v-btn
          v-if="showScoring"
          icon
          title="Score"
          class="userPilotLCScore"
          @click="toggleRHS('score')"
          ><v-icon :color="rightPanel === 'score' ? 'success' : ''"
            >mdi-text-box-check-outline</v-icon
          ></v-btn
        >
        <v-btn
          icon
          title="Suggestions"
          class="userPilotLCSuggestions"
          @click="toggleRHS('suggestions')"
          ><v-icon :color="rightPanel === 'suggestions' ? 'success' : ''"
            >mdi-format-list-checkbox</v-icon
          ></v-btn
        >
        <v-btn
          icon
          v-if="showSkillsPanel"
          title="Skills"
          class="userPilotLCSkills"
          @click="toggleRHS('skills')"
          ><v-icon :color="rightPanel === 'skills' ? 'success' : ''"
            >mdi-head-lightbulb</v-icon
          ></v-btn
        >
        <v-btn
          icon
          title="Database"
          class="userPilotLCDatabase"
          @click="toggleRHS('database')"
          ><v-icon :color="rightPanel === 'database' ? 'success' : ''"
            >mdi-database</v-icon
          ></v-btn
        > -->
        <!--<v-badge
                    color="success"
                    dot
                    :value="allHistory.length"
                    :content="allHistory.length"
                    offset-x="11px"
                    offset-y="13px"
                    dense
                >
                    <v-btn icon title="History" class="userPilotLCHistory" @click="toggleRHS('allHistory')"><v-icon :color="rightPanel==='allHistory'||rightPanel==='history' ? 'success' : ''">mdi-history</v-icon></v-btn>
                </v-badge>-->
        <!--<v-btn icon title="Collaboration" class="userPilotLCCollaboration" @click="toggleRHS('collaboration')"><v-icon :color="rightPanel==='collaboration' ? 'success' : ''">mdi-account-group-outline</v-icon></v-btn>
                <v-btn icon title="Dynamic Content Engine" class="userPilotLCDCE" @click="toggleRHS('DCE')"><v-icon :color="rightPanel==='DCE' ? 'success' : ''">memory</v-icon></v-btn>-->
      </div>
      <div class="rightHolderContent" v-if="rightPanel !== 'hidden'">
        <div justify-center v-if="rightPanelHeader" class="doc-view-font rightHolderContentLabel">
          <div>
            {{ rightPanelHeader }}
            {{
              rightPanelHeader === "Suggestions" && suggestionPart
                ? `- ${suggestionPart.type}`
                : ""
            }}
            
          </div>
          <v-btn color="primary" v-if="!showRHSTabs" @click="toggleRHS('score')" small icon
            ><v-icon>mdi-close-thick</v-icon></v-btn
          >
        </div>
        <div class="doc-view-font small rightHolderContentMain">
          <div
            v-if="rightPanel === 'history'"
            style="
              width: 100%;
              height: 100%;
              max-height: 100%;
              overflow: hidden scroll;
            "
          >
            <v-card-text v-if="collabHistory" class="pa-0">
              <v-tabs
                v-if="collabHistory"
                v-model="comment.tab"
                centered
                background-color="transparent"
              >
                <v-tab>Comments</v-tab>
                <v-tab
                  v-if="
                    history &&
                    history.collabSummary.filter((x) => x.type !== 'comment')
                      .length
                  "
                  >Changes</v-tab
                >
              </v-tabs>
              <v-tabs-items
                v-model="comment.tab"
                style="background-color: transparent !important"
              >
                <v-tab-item>
                  <DocumentComments
                    :document="document"
                    :doc_part_id="comment.part.doc_part_id"
                    :dpa_tag_id="comment.tag?.dpa_tag_id"
                    @saved="comment.tag ? comment.tag.hasComments = true : comment.part.hasComments = true"
                    hideHeader
                  ></DocumentComments>
                </v-tab-item>
                <v-tab-item
                  v-if="
                    history &&
                    history.collabSummary.filter((x) => x.type !== 'comment')
                      .length
                  "
                >
                  <v-timeline dense>
                    <v-timeline-item
                      small
                      v-for="(h, hi) in history.collabSummary.filter(
                        (x) => x.type !== 'comment'
                      )"
                      :key="'ch' + hi"
                    >
                      <template v-slot:icon>
                        <v-avatar
                          :color="h.type === 'comment' ? 'primary' : 'teal'"
                          size="30"
                        >
                          <span class="white--text">{{ h.user_initials }}</span>
                        </v-avatar>
                      </template>
                      <v-card v-if="h.type === 'comment'" class="elevation-2">
                        <v-card-text>
                          <v-icon size="22" class="mr-2">
                            mdi-comment-text-outline
                          </v-icon>
                          <strong
                            >{{ h.data.created_date }}:
                            {{ h.user_name }}: </strong
                          ><br />
                          <q>{{ h.data.comment }}</q></v-card-text
                        >
                      </v-card>
                      <v-sheet
                        v-else
                        rounded
                        elevation="2"
                        style="padding: 2px 12px"
                      >
                        <p class="font-weight-normal overflow-hidden">
                          <v-icon size="22" class="mr-2">
                            mdi-pencil-outline
                          </v-icon>
                          <strong>{{ h.data.version_collab_desc }}</strong>
                          <v-chip
                            small
                            v-if="h.data.latest"
                            class="float-right"
                            outlined
                            label
                          >
                            Latest Version</v-chip
                          >
                          <v-btn
                            v-else-if="
                              !h.data.latest && document.state.canEditDocParts
                            "
                            class="float-right mb-1 mr-1"
                            small
                            @click="
                              doReviewRevert({
                                rc: h.data,
                                processed: false,
                                part: comment.part,
                                partType: comment.partType,
                              })
                            "
                            >Revert To</v-btn
                          >
                        </p>
                        <p class="overflow-hidden">
                          {{ h.data.previous }}
                          <v-chip
                            class="float-right"
                            small
                            color="primary"
                            v-if="h.data.previous_is_essential !== null"
                          >
                            {{
                              h.data.previous_is_essential
                                ? "Essential"
                                : "Not Essential"
                            }}
                          </v-chip>
                        </p>
                      </v-sheet>
                    </v-timeline-item>
                  </v-timeline>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
            <v-card-text v-else-if="ptDeleteHistory && ptDeleteHistory.length">
              <v-timeline dense>
                <v-timeline-item
                  small
                  v-for="(dh, hi) in ptDeleteHistory"
                  :key="'dh' + hi"
                >
                  <v-row dense>
                    <v-col>
                      <h5 class="subtitle-2">
                        {{ dh.items[0].version_desc }}
                      </h5>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="d-flex justify-space-between">
                      <span class="histText" v-html="dh.items[0].text"></span>
                      <v-btn
                        icon
                        v-if="
                          dh.items[0].canRevert &&
                          document.state.canEditDocParts &&
                          (document.state.allow_errors ||
                            ptDeleteHistoryPT.parts.length <
                              ptDeleteHistoryPT.tmpl_part_metadata.multi_row)
                        "
                        x-small
                        title="Undo"
                        @click="revertDelete(dh)"
                        ><v-icon>mdi-undo-variant</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
            <v-card-text v-else>
              <v-timeline dense>
                <v-timeline-item
                  small
                  v-for="(h, hi) in history?.items"
                  :key="'h' + hi"
                >
                  <v-row dense>
                    <v-col class="d-flex justify-space-between">
                      <h5 class="subtitle-2">
                        {{ h.version_desc }}
                      </h5>
                      <v-btn
                        v-if="h.canRevert && document.state.canEditDocParts"
                        x-small
                        icon
                        title="Revert"
                        @click="revertChange(h)"
                        ><v-icon>mdi-undo-variant</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                  <v-row
                    dense
                    v-for="(c, ci) in h.changes"
                    :key="'h' + hi + 'c' + ci"
                  >
                    <v-col cols="3">
                      <strong class="histText">{{ c.title }}</strong>
                    </v-col>
                    <v-col>
                      <span class="histText" v-html="c.desc"></span>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </div>
          <div
            v-if="rightPanel === 'allHistory'"
            style="
              padding-right: 15px;
              width: 100%;
              height: 100%;
              max-height: 100%;
              overflow: hidden scroll;
              padding-left: 20px;
            "
          >
            <div v-if="activeSection.section_history.length === 0">
              No History!
            </div>
            <v-timeline v-else align-top dense>
              <v-timeline-item
                v-for="(item, i) in activeSection.section_history"
                :key="i"
                :color="
                  item.items[0].type === 'Section'
                    ? '#4caf50bf !important'
                    : '#2196f38c'
                "
                :icon="
                  item.items[0].type === 'Section'
                    ? 'mdi-check'
                    : 'mdi-book-variant'
                "
                class="doc-view-font small"
              >
                <v-card
                  dark
                  class="white"
                  :color="
                    item.items[0].type === 'Section'
                      ? '#4caf50bf !important'
                      : '#2196f38c !important'
                  "
                >
                  <v-card-title
                    class="doc-view-font small light"
                    style="padding: 5px 5px 5px 15px"
                  >
                    {{
                      item.items[0].type === "Section"
                        ? "Section Update"
                        : "Content Update"
                    }}
                  </v-card-title>
                  <v-card-text
                    class="white text--primary"
                    style="padding: 5px 5px 5px 15px"
                  >
                    {{
                      `${moment(item.timestamp).format(
                        "DD MMM YYYY HH:mm:ss"
                      )}`
                    }}:<br />
                    <div
                      v-for="change in item.items"
                      :key="change.doc_view_audit_id"
                    >
                      <div v-if="change.content_type === 'TABLE'">
                        {{ `${item.user}` }}<br />
                        <span v-html="change.message"></span>
                      </div>
                      <div v-else>
                        <div
                          v-for="(value, index) in Object.entries(change.data)"
                          :key="index"
                        >
                          <div v-if="change.type === 'Section'">
                            {{ `${item.user}` }}<br />
                            {{ `Section Complete` }}
                          </div>
                          <div v-else>
                            <span>{{
                              `${item.user} Updated: ${value[0]} to: `
                            }}</span
                            ><br />
                            <span>{{
                              `${value[1] === "" ? "-" : value[1]}`
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </div>
          <div
            v-if="rightPanel === 'score' && !admin && showScoring"
            class="scorePanel"
          >
          <div class="rhsExpansionHeader" v-if="showRHSExpansionHeaders" @click="scoreExpanded = !scoreExpanded">
            <span class="doc-view-font"><v-icon>{{ scoreExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
              {{ document.score_title }}
            </span>
            <v-progress-circular
              v-if="
                documentIssueDisplay === 'score' ||
                documentIssueDisplay === 'score_header_only'
              "
              :rotate="270"
              :size="35"
              :width="4"
              :value="checkSummary.score"
              :color="checkSummary.scoreColour"
              ><span class="scoreValue">{{ checkSummary.score.toFixed(0) }}</span>
            </v-progress-circular>
          </div>
          <div class="rhsExpansionHeader" v-if="!showRHSExpansionHeaders">
            <div>
              <v-btn
                icon
                small
                @click="allCheckSummaryPanels"
                v-if="
                  checkSummaryPanels.length < activeSummaryCategories.length
                "
              >
                <v-icon>mdi-chevron-double-down</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                @click="closeCheckSummaryPanels"
                v-if="
                  checkSummaryPanels.length === activeSummaryCategories.length
                "
              >
                <v-icon>mdi-chevron-double-up</v-icon>
              </v-btn>
              <span class="inclusionHeading doc-view-font">
                {{ document.score_title }}
              </span>
            </div>
            <v-progress-circular
              v-if="
                documentIssueDisplay === 'score' ||
                documentIssueDisplay === 'score_header_only'
              "
              :rotate="270"
              :size="35"
              :width="4"
              :value="checkSummary.score"
              :color="checkSummary.scoreColour"
              ><span class="scoreValue">{{ checkSummary.score.toFixed(0) }}</span>
            </v-progress-circular>
          </div>
            <v-card v-show="scoreExpanded" flat class="scorecard">
              <v-card-text color="transparent" dense style="padding: 0">
                <v-expansion-panels
                  accordion
                  multiple
                  flat
                  tile
                  v-model="checkSummaryPanels"
                >
                  <v-expansion-panel
                    v-for="(i, ii) in checkSummary.categories"
                    :key="'i' + ii"
                  >
                    <v-expansion-panel-header
                      :disabled="i.score == '100'"
                    >
                      <span class="sectionText doc-view-font">
                        {{ i.category.trim() + " " }}
                        <v-tooltip
                          bottom
                          v-if="
                            (documentIssueDisplay === 'score_header_only' ||
                              documentIssueDisplay === 'basic') &&
                            i.errorCount &&
                            !i.hasPartVisible
                          "
                          ><template v-slot:activator="{ on, attrs }"
                            ><v-avatar
                              v-bind="attrs"
                              v-on="on"
                              :content="i.errorCount"
                              color="blue-grey lighten-4"
                              size="20"
                              ><span class="white--text text-caption">{{
                                i.errorCount
                              }}</span>
                            </v-avatar>
                          </template>
                          <div style="max-width: 300px">
                            <span v-html="hiddenPartIssueMessage"></span>
                          </div>
                        </v-tooltip>
                        <v-badge
                          v-if="
                            (documentIssueDisplay === 'score_header_only' ||
                              documentIssueDisplay === 'basic') &&
                            i.errorCount &&
                            i.hasPartVisible
                          "
                          :content="i.errorCount"
                          color="red"
                          inline
                          overlap
                        >
                        </v-badge>
                        <v-tooltip
                          bottom
                          v-if="
                            (documentIssueDisplay === 'score_header_only' ||
                              documentIssueDisplay === 'basic') &&
                            i.warningCount &&
                            !i.hasPartVisible
                          "
                          ><template v-slot:activator="{ on, attrs }"
                            ><v-avatar
                              v-bind="attrs"
                              v-on="on"
                              color="blue-grey lighten-3"
                              size="20"
                              ><span class="white--text text-caption">{{
                                i.warningCount
                              }}</span>
                            </v-avatar>
                          </template>
                          <div style="max-width: 300px">
                            <span v-html="hiddenPartIssueMessage"></span>
                          </div>
                        </v-tooltip>
                        
                        <v-badge
                          v-if="
                            (documentIssueDisplay === 'score_header_only' ||
                              documentIssueDisplay === 'basic') &&
                            i.warningCount &&
                            i.hasPartVisible
                          "
                          :content="i.warningCount"
                          color="amber"
                          inline
                          overlap
                        >
                        </v-badge>
                        <v-progress-circular
                          v-if="documentIssueDisplay === 'score'"
                          :rotate="90"
                          :size="30"
                          :width="4"
                          :value="i.score"
                          :color="i.scoreColour"
                          class="float-right"
                          ><span style="font-size: 11px"> {{ i.score }}</span>
                        </v-progress-circular> </span
                      >
                      <v-spacer></v-spacer>
                      <v-icon v-if="i.score == '100'"> mdi-check </v-icon>
                      <template v-if="i.score == '100'" v-slot:actions>
                        <v-icon style="opacity: 50%">mdi-chevron-down</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content v-if="checkSummaryView === 1">
                      <v-row
                        dense
                        v-for="(c, ci) in i.titles"
                        :key="'i' + ii + 'ci' + ci">
                        <v-col>
                          <v-row dense class="scoreDetail doc-view-font">
                            <v-col cols="1"></v-col>
                            <v-col cols="11"
                              ><span>{{
                                c.title
                              }}</span></v-col
                            >
                          </v-row>
                          <v-row
                            dense
                            class="scoreDetail doc-view-font"
                            v-for="(e, ei) in checkSummary.errors.filter(
                              (x) =>
                                x.category === i.category && x.title === c.title
                            )"
                            :key="'e_' + ii + '_' + ei"
                          >
                            <v-col cols="1"></v-col>
                            <v-col
                              cols="11"
                              @mouseenter="highlightSection(e)"
                              @mouseleave="unhighlightSection"
                              @click="scrollToSection(e)"
                              class="sectionItem"
                            >
                              <v-badge
                                color="red"
                                :content="e.count"
                                inline
                                overlap
                                style="color: slategray; font-size: 12px"
                              >
                                <div
                                  :style="{
                                    'min-width': '22px',
                                    height:
                                      e.effect === 'highlight' ? '22px' : '',
                                    'margin-right': '10px',
                                    'background-color':
                                      e.effect === 'highlight'
                                        ? e.colour
                                        : 'transparent',
                                    'border-bottom':
                                      e.effect.indexOf('dotted') >= 0
                                        ? 'dotted 3px ' + e.colour
                                        : e.effect.indexOf('solid') >= 0
                                        ? 'solid 3px ' + e.colour
                                        : '',
                                  }"
                                ></div>
                                <div v-html="e.description"></div>
                              </v-badge>
                            </v-col>
                          </v-row>
                          <v-row
                            dense
                            class="scoreDetail doc-view-font"
                            v-for="(w, wi) in checkSummary.warnings.filter(
                              (x) =>
                                x.category === i.category && x.title === c.title
                            )"
                            :key="'w_' + ii + '_' + wi"
                          >
                            <v-col cols="1"></v-col>
                            <v-col
                              cols="11"
                              @mouseenter="highlightSection(w)"
                              @mouseleave="unhighlightSection"
                              @click="scrollToSection(w)"
                              class="sectionItem doc-view-font"
                            >
                              <v-badge
                                color="amber"
                                :content="w.count"
                                inline
                                overlap
                                style="color: slategray; font-size: 12px"
                              >
                                <div
                                  :style="{
                                    'min-width': '22px',
                                    height:
                                      w.effect === 'highlight' ? '22px' : '',
                                    'margin-right': '10px',
                                    'background-color':
                                      w.effect === 'highlight'
                                        ? w.colour
                                        : 'transparent',
                                    'border-bottom':
                                      w.effect.indexOf('dotted') >= 0
                                        ? 'dotted 3px ' + w.colour
                                        : w.effect.indexOf('solid') >= 0
                                        ? 'solid 3px ' + w.colour
                                        : '',
                                  }"
                                ></div>
                                <div v-html="w.description"></div>
                              </v-badge>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content
                      v-if="checkSummaryView === 2"
                      style="margin-top: -12px"
                    >
                      <v-expansion-panels
                        accordion
                        flat
                        tile
                      >
                        <v-expansion-panel
                          v-for="(t, ti) in i.titles"
                          :key="'i' + ii + 'ti' + ti"
                        >
                          <v-expansion-panel-header>
                            <v-row
                              dense
                              class="scoreDetail doc-view-font"
                            >
                                <span
                                  v-for="(d, di) in t.issues"
                                  :key="'i' + ii + 'ti' + ti + 'di' + di"
                                >
                                  <v-tooltip bottom v-if="d.errorCount > 0">
                                    <template v-slot:activator="{ on, attrs }"
                                      ><v-btn
                                        x-small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @mouseenter="highlightSection(d, true)"
                                        @mouseleave="unhighlightSection"
                                        @click.stop="scrollToSection(d)"
                                        class="sectionItem doc-view-font"
                                      >
                                        <v-icon
                                          :color="
                                            d.hasPartVisible ? 'error' : 'error lighten-4'
                                          "
                                          style="font-size: 18px"
                                          >mdi-alert</v-icon
                                        >
                                        <span
                                          v-if="d.errorCount > 1"
                                          class="errorCount"
                                          >x{{ d.errorCount }}</span
                                        >
                                        <span v-else class="errorCount"></span></v-btn
                                      >
                                    </template>
                                    <div style="max-width: 300px">
                                      <span
                                        v-html="
                                          d.description +
                                          (d.hasPartVisible
                                            ? ''
                                            : '<br/><br/><hr/><br/><u>NOTE:</u><br/>' +
                                              hiddenPartIssueMessage)
                                        "
                                      ></span>
                                    </div>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="d.warningCount > 0">
                                    <template v-slot:activator="{ on, attrs }"
                                      ><v-btn
                                        x-small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @mouseenter="highlightSection(d)"
                                        @mouseleave="unhighlightSection"
                                        @click.stop="scrollToSection(d)"
                                        class="sectionItem doc-view-font"
                                      >
                                        <v-icon
                                          :color="
                                            d.hasPartVisible
                                              ? 'warning'
                                              : 'warning lighten-3'
                                          "
                                          style="font-size: 18px"
                                          >mdi-alert</v-icon
                                        >
                                        <span
                                          v-if="d.warningCount > 1"
                                          class="errorCount"
                                          >x{{ d.warningCount }}</span
                                        >
                                        <span v-else class="errorCount"></span></v-btn
                                      >
                                    </template>
                                    <div style="max-width: 300px">
                                      <span
                                        v-html="
                                          d.description +
                                          (d.hasPartVisible
                                            ? ''
                                            : '<br/><br/><hr/><br/><u>NOTE:</u><br/>' +
                                              hiddenPartIssueMessage)
                                        "
                                      ></span>
                                    </div>
                                  </v-tooltip>
                                </span>
                                <div v-if="t.effect !== 'border' && t.effect.substr(0, 5) !== 'icon-'"
                                  :style="{
                                    'margin-left': '5px',
                                    'margin-top': '3px',
                                    'width': '18px',
                                    height:
                                      t.effect === 'highlight' ||
                                      t.effect === 'border'
                                        ? '18px'
                                        : '12px',
                                    'background-color':
                                      t.effect === 'highlight'
                                        ? t.colour
                                        : 'transparent',
                                    'border-bottom':
                                      t.effect.indexOf('dotted') >= 0
                                        ? 'dotted 3px ' + t.colour
                                        : t.effect.indexOf('solid') >= 0
                                        ? 'solid 3px ' + t.colour
                                        : t.effect === 'border'
                                        ? 'solid 1px ' + t.colour
                                        : '',
                                    'border-top':
                                      t.effect === 'border'
                                        ? 'solid 1px ' + t.colour
                                        : '',
                                    'border-left':
                                      t.effect === 'border'
                                        ? 'solid 1px ' + t.colour
                                        : '',
                                    'border-right':
                                      t.effect === 'border'
                                        ? 'solid 1px ' + t.colour
                                        : '',
                                    'border-radius':
                                      t.effect === 'border' || t.effect === 'highlight' ? '9px ' : '',
                                  }"
                                >
                                  <v-icon v-if="t.effect.substr(0, 5) === 'icon-'">{{
                                    t.effect.substr(5)
                                  }}</v-icon>
                                </div>
                                <span class="ml-1">{{
                                  t.title
                                }}</span>
                            </v-row>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div v-for="(d, di) in t.issues"
                                :key="'i' + ii + 'ti' + ti + 'di' + di">
                                <span v-html="d.description"></span>
                                <v-btn small text
                                  @mouseenter="highlightSection(d, true)"
                                  @mouseleave="unhighlightSection"
                                  @click="scrollToSection(d)"
                                  color="success">Edit</v-btn>
                                <div v-for="(c, ci) in d.items.filter(c => c.chartData?.length)" :key="'i' + ii + 'ti' + ti + 'di' + di + 'ci' + ci">
                                  <DoughnutChart
                                    :chartData="c.chartData"
                                    :height="60"
                                    :width="240"
                                    :showLegend="true">
                                  </DoughnutChart>
                                </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content
                      v-if="checkSummaryView === 3"
                      style="margin-top: -12px"
                    >
                      <v-row
                        dense
                        class="scoreDetail"
                        v-for="(t, ti) in i.titles"
                        :key="'i' + ii + 'ti' + ti"
                      >
                        <v-col cols="1">
                          <div
                            :style="{
                              'margin-top': '3px',
                              height:
                                t.effect === 'highlight' ? '18px' : '12px',
                              'background-color':
                                t.effect === 'highlight'
                                  ? t.colour
                                  : 'transparent',
                              'border-bottom':
                                t.effect.indexOf('dotted') >= 0
                                  ? 'dotted 3px ' + t.colour
                                  : t.effect.indexOf('solid') >= 0
                                  ? 'solid 3px ' + t.colour
                                  : '',
                            }"
                          ></div>
                        </v-col>
                        <v-col cols="8">
                          <span style="margin-right: 10px">{{
                            t.title
                          }}</span>
                        </v-col>
                        <v-col cols="3">
                          <div
                            style="
                              width: 100%;
                              border: solid #f0e8e8 1px;
                              height: 19px;
                            "
                          >
                            <div
                              v-for="n in t.errorCount"
                              :key="'i' + ii + 'ti' + ti + 'n' + n"
                              :style="{
                                width: 100 / checkSummary.maxIssues - 2 + '%',
                                'background-color': 'red',
                                margin: '1%',
                                float: 'left',
                                height: '15px',
                              }"
                            ></div>
                            <div
                              v-for="n in t.warningCount"
                              :key="'i' + ii + 'ti' + ti + 'n' + n"
                              :style="{
                                width: 100 / checkSummary.maxIssues - 2 + '%',
                                'background-color': 'orange',
                                margin: '1%',
                                float: 'left',
                                height: '15px',
                              }"
                            ></div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
            <DocumentComments
              v-if="data.showComments"
              class="mt-4"
              :document="document"
              @closed="$emit('hideComments')"
            >
            </DocumentComments>
            <div class="rhsExpansionHeader justify-start" v-if="docMatches.data.length > 0 && showRHSExpansionHeaders" @click="similaritiesExpanded = !similaritiesExpanded">
              <v-icon>{{ similaritiesExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon> Similar Documents
              <v-chip small class="ml-2">
                {{ docMatches.data.length }}
              </v-chip>
              <v-chip small v-if="docMatches.highlight" color="warning"
                :class="{ 'ml-2': true, 'blinking': docMatches.blinking }"
                close close-icon="mdi-close"
                @click:close="docMatches.highlight = false">
                New
              </v-chip>
            </div>
            <div style="padding-top:15px" v-if="docMatches.data.length > 0 && showSimilaritiesPanel && similaritiesExpanded">
              <DocumentSimilarityPanel :matches="docMatches.data" @initCompare="initCompare" @quickView="quickView"></DocumentSimilarityPanel>
            </div>
          </div>
          <div
            v-if="rightPanel === 'suggestions'"
            style="
              padding-top: 5px;
              padding-right: 15px;
              width: 100%;
              height: 100%;
              max-height: 100%;
            "
          >
            <SuggestionsPanel
              ref="suggestionsPanel"
              :part="suggestionsData"
              :docList="[docTitle]"
              :languageCode="document.language_code"
              @dragEnd="dragEnd"
              @dragStart="initDrag"
              @close="closeSuggestionsPanel"
            ></SuggestionsPanel>
          </div>
          <div
            v-if="rightPanel === 'skills'"
            style="
              padding-top: 5px;
              padding-right: 15px;
              width: 100%;
              height: 100%;
              max-height: 100%;
              padding-left: 10px;
            "
          >
            <div style="width: 100%; display:inline-flex;">
              <v-btn color="primary" outlined @click="getSkills" :disabled="skillsLoading">Get Skills</v-btn> &nbsp; 
              <div style="color:red; font-size: 12px; padding-top:6px; padding-left:5px" v-if="skillsResponse.Status !== 'OK'">Error : {{ skillsResponse.Message }}</div>
              
              <div v-if="skillsLoading" class="pa-1">
                <v-progress-circular
                :width="3"
                :size="25"
                color="green"
                indeterminate
              ></v-progress-circular>
              </div>
            </div>
            <div style="padding-top:15px; max-height:calc(100% - 40px);; overflow:hidden scroll" v-if="skillsResponse.Data.length > 0">
              <hr/>
              <br/>
              <v-tabs class="navTabs" v-model="skillsTab" grow>
                <v-tab class="tab ma-0 pa-0" v-for="skillType in skillsResponse.Data" :key="`skillTab_${skillType.type}`">
                  {{ skillType.type }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="skillsTab">
                <v-tab-item style="height:100%" v-for="skillType in skillsResponse.Data" :key="`skill_${skillType.type}`">
                  <v-list-item-group>
                    <v-list-item v-for="skill in skillType.items" :key="`skill_${skill.skill_id}`">
                      {{ skill.client_name ?? skill.name }} 
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" color="primary" dark v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span v-if="skill.client_name">Original Skill Name: {{ skill.name }}<br/><br/></span>
                        <span>Inferred from the following phrases: <br/> {{ skill.skill_raw_data}}</span>
                      </v-tooltip>
                    </v-list-item>
                  </v-list-item-group>
                </v-tab-item> 
              </v-tabs-items>
              <div >

              </div>
            </div>
          </div>
          <div
            v-if="rightPanel === 'comments'"
            style="
              width: 100%;
              height: 100%;
              max-height: 100%;
            ">
            <DocumentComments
              v-if="data.showComments"
              class="mt-4"
              :document="document"
              @closed="$emit('hideComments'); toggleRHS('score')"
            >
            </DocumentComments>
          </div>
          <div
            v-if="rightPanel === 'database'"
            style="
              width: 100%;
              height: 100%;
              max-height: 100%;
            "
          >
            <ContentDatabase
              :document="data.document"
              :activeSection="activeSection"
              :sourceFile="sourceFile"
              :docMatches="docMatches"
              :isNew="false"
              @dragEnd="dragEnd"
              @dragStart="initDrag"
              @closeDatabasePanel="toggleRHS('score')"
              @triggerNotification="triggerNotification"
              @sourceFileDeleted="sourceFile = null"
              @initCompare="initCompare"
              @openDocument="openDocument"
            ></ContentDatabase>
          </div>
          <div
            v-if="rightPanel === 'contentGen'"
            style="
              width: 100%;
              height: 100%;
              max-height: 100%;
            "
          >
            <GenerateContent
              ref="generateContentPanelRef"
              :doc="generateContentData.doc"
              :prompt_chain="generateContentData.prompt_chain"
              @accept="(data) => acceptContentGen(data, false)"
              @statusChange="(status) => generateContentDialog.status = status"
              @executionStarted="handleExecutionStarted"
            />
          </div>
          <ViewSectionAdmin
            :display="'inline'"
            v-if="
              (rightPanel === 'partPermissions' ||
                rightPanel === 'permissions') &&
              admin &&
              editingSection
            "
            @changeRHS="changePanel"
            :workflowConfig="adminConfig"
            :value="editingSection"
            :sectionList="allSectionList"
            @preview="applySectionUpdate"
            @cancel="cancelEditUpdate"
            @configParts="loadPartsForSection"
            @saveSection="saveSection"
          >
          </ViewSectionAdmin>
          <div
            v-if="rightPanel === 'all-comments'"
            style="
              width: 100%;
              height: 100%;
              max-height: 100%;
            ">
            <DocumentComments
              class="mt-4"
              :document="document"
              all hideHeader :target_doc_part="comment_doc_part"
              @mouseenter="highlightSectionForCommentHover"
              @mouseleave="highlightSectionForCommentHover(null)"
              @commentclick="scrollToSectionForComment"
              @resetCommentPart="resetSectionForComment"
              @saved="commentSaved"
              @commentResolved="commentResolved"
            >
            </DocumentComments>
          </div>
          <div
            v-if="rightPanel === 'atlas' && utils.atlasFlyoutAvailable($loginState)"
            class="atlas-tab-host"
            style="
              width: 100%;
              height: 100%;
              max-height: 100%;
            "
          >
            <!--
              While `pendingSuggestions` is populated the per-part
              review wizard takes over the Atlas tab. The chat flyout
              can't host the textarea + item-toggle UI inside a chat
              bubble without becoming cramped, so we replace the
              surface for the duration of the review. Wizard's
              done/cancel clears pendingSuggestions, dropping back to
              the chat without losing it.
            -->
            <AtlasSuggestionReview
              v-if="pendingSuggestions && pendingSuggestions.length > 0"
              :suggestions="pendingSuggestions"
              :trigger-message="pendingSuggestionsMessage"
              :replace-targets="suggestionReplaceTargets"
              :apply-handler="applySuggestion"
              @done="pendingSuggestions = null; pendingSuggestionsMessage = null"
              @cancel="pendingSuggestions = null; pendingSuggestionsMessage = null"
            />
            <AtlasFlyout v-else inline @openDocument="openAtlasDocument" />
          </div>
        </div>
      </div>
    </div>
    <Loading :isVisible="isLoading" />
    <v-dialog v-model="editPartDialog.show" max-width="1200px" scrollable>
      <v-card>
        <v-card-title class="d-flex align-center">
          Edit Parts in Section
        </v-card-title>
        <v-card-text style="display: inline-flex">
          <!--<v-row class="dataTableView" v-for="(item,idx) in editPartDialog.data" :key="idx" dense>
                        <v-col cols="1">
                            <v-checkbox dense v-model="item.exists"></v-checkbox>
                        </v-col>
                        {{ item.pt_name }}
                    </v-row>-->
          <div style="width: 25%">
            Available Parts:<br />
            <div
              style="
                height: 700px;
                max-height: 700px;
                overflow: hidden scroll;
                padding-top: 10px;
              "
            >
              <v-row
                class="dataTableView"
                v-for="(item, idx) in editPartDialog.available"
                :key="idx"
                dense
              >
                <v-col cols="11">
                  {{ item.tp_name }}
                </v-col>
                <v-col cols="1">
                  <v-icon
                    color="success"
                    @click="addPartToSection(item)"
                    right
                    style="right: 25px"
                  >
                    mdi-chevron-double-right
                  </v-icon>
                  <!-- <v-icon color="error" @click="removePartFromSection(item)" v-if="item.exists" right style="right:25px">
                                        mdi-chevron-double-left
                                    </v-icon>-->
                </v-col>
              </v-row>
            </div>
          </div>
          <div style="width: 75%">
            <div v-if="editPartDialog.editMode === 'section'">
              <span style="padding-left: 25px">
                Active Parts:
                <v-icon
                  title="Add Related Content Part"
                  style="
                    display: inline-flex;
                    font-size: 20px !important;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  @click="addContentPart()"
                  >mdi-plus-circle</v-icon
                >
                <v-icon
                  title="Add Part Group"
                  style="
                    display: inline-flex;
                    font-size: 20px !important;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  @click="addPartGroup()"
                  >mdi-group</v-icon
                > </span
              ><br />
              <div
                style="
                  height: 700px;
                  max-height: 700px;
                  overflow: hidden scroll;
                  padding-top: 10px;
                "
              >
                <draggable
                  tag="ul"
                  @change="onChange"
                  :list="editPartDialog.data"
                  class="list-group"
                  handle=".dragHandle"
                >
                  <div
                    v-for="(element, idx) in editPartDialog.data"
                    class="dataTableView"
                    :key="idx"
                  >
                    <v-row
                      v-if="
                        element.tmpl_part_metadata.contentPart &&
                        element.tmpl_part_metadata.content_type === 'GROUP'
                      "
                      dense
                      align="center"
                      justify="center"
                    >
                      <v-col cols="1" justify-center align="center">
                        <v-icon style="display: inline-flex" class="dragHandle"
                          >mdi-drag-variant</v-icon
                        >
                      </v-col>
                      <v-col cols="9">GROUP!</v-col>
                      <v-col
                        cols="2"
                        style="display: inline-flex"
                        align="right"
                      >
                        <v-switch
                          dense
                          v-model="element.tmpl_part_metadata.active"
                        ></v-switch>
                        <v-icon
                          title="Delete Part"
                          style="
                            padding-left: 5px;
                            display: inline-flex;
                            font-size: 20px !important;
                          "
                          @click="removeAt(idx)"
                          >mdi-delete</v-icon
                        >
                        <v-icon
                          v-if="element.tmpl_part_id === null"
                          title="Edit"
                          style="
                            padding-left: 5px;
                            display: inline-flex;
                            font-size: 20px !important;
                          "
                          @click="editContentGroup(element)"
                          >mdi-cog</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-row v-else dense align="center" justify="center">
                      <v-col cols="1" justify-center align="center">
                        <v-icon style="display: inline-flex" class="dragHandle"
                          >mdi-drag-variant</v-icon
                        >
                      </v-col>
                      <v-col cols="9" style="padding-top: 10px">
                        <div v-if="element.tmpl_part_id !== null">
                          {{ element.type }}
                          <span
                            v-if="element.toDelete"
                            style="
                              color: red;
                              font-weight: bold;
                              font-style: italic;
                            "
                          >
                            - To Delete</span
                          >
                        </div>
                        <div
                          v-if="
                            !element.tmpl_part_id ||
                            element.tmpl_part_id === null
                          "
                        >
                          {{ element.tmpl_part_metadata.content_name }}
                          <span
                            v-if="element.toDelete"
                            style="
                              color: red;
                              font-weight: bold;
                              font-style: italic;
                            "
                          >
                            - To Delete</span
                          >
                        </div>
                      </v-col>
                      <v-col
                        cols="2"
                        style="display: inline-flex"
                        align="right"
                      >
                        <v-switch
                          dense
                          v-model="element.tmpl_part_metadata.active"
                        ></v-switch>
                        <v-icon
                          title="Delete Part"
                          style="
                            padding-left: 5px;
                            display: inline-flex;
                            font-size: 20px !important;
                          "
                          @click="removeAt(idx)"
                          >mdi-delete</v-icon
                        >
                        <v-icon
                          title="Add Related Content Part"
                          style="
                            padding-left: 5px;
                            display: inline-flex;
                            font-size: 20px !important;
                          "
                          @click="addContentPart(element)"
                          >mdi-plus-circle</v-icon
                        >
                        <v-icon
                          v-if="element.tmpl_part_id === null"
                          title="Edit"
                          style="
                            padding-left: 5px;
                            display: inline-flex;
                            font-size: 20px !important;
                          "
                          @click="editContentPart(element)"
                          >mdi-cog</v-icon
                        >
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          element.tmpl_part_metadata.linked_content.length > 0
                        "
                      >
                        <v-row
                          v-for="(sub, sidx) in element.tmpl_part_metadata
                            .linked_content"
                          :key="sidx"
                          style="padding-left: 125px; padding-right: 10px"
                          align="center"
                          justify="center"
                        >
                          <v-col cols="10">
                            {{ sub.tmpl_part_metadata.content_name }}
                            <span
                              v-if="sub.toDelete"
                              style="
                                color: red;
                                font-weight: bold;
                                font-style: italic;
                              "
                            >
                              - To Delete</span
                            >
                          </v-col>
                          <v-col
                            cols="2"
                            style="display: inline-flex"
                            align="right"
                          >
                            <v-switch
                              dense
                              v-model="sub.tmpl_part_metadata.active"
                            ></v-switch>
                            <v-icon
                              title="Delete Part"
                              style="
                                padding-left: 5px;
                                display: inline-flex;
                                font-size: 20px !important;
                              "
                              @click="removeRelatedAt(sidx, idx)"
                              >mdi-delete</v-icon
                            >
                            <v-icon
                              title="Edit"
                              style="
                                padding-left: 5px;
                                display: inline-flex;
                                font-size: 20px !important;
                              "
                              @click="editContentPart(sub, element)"
                              >mdi-cog</v-icon
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </draggable>
              </div>
            </div>
            <div v-if="editPartDialog.editMode === 'group'">
              <div style="padding: 25px">
                EDIT GROUP:
                <div style="display: inline-flex; vertical-align: middle">
                  <v-text-field
                    v-model="newTableConfig.row_count"
                    style="width: 150px"
                    prepend-icon="mdi-view-agenda"
                    dense
                    type="number"
                  />
                  <v-text-field
                    v-model="newTableConfig.col_count"
                    style="width: 150px"
                    prepend-icon="mdi-view-column"
                    dense
                    type="number"
                  />
                  <v-btn small @click="generateTable">Create</v-btn>
                </div>
                <div v-if="newTableConfig.rows.length > 0">
                  <table
                    id="table"
                    width="100%"
                    class="contentTable"
                    cellspacing="0"
                    cellpadding="0"
                    :style="cssVars"
                  >
                    <tr v-for="(row, rIdx) in newTableConfig.rows" :key="rIdx">
                      <td
                        v-for="(cell, cIdx) in row.cells"
                        :key="cIdx"
                        :colspan="cell.col_span"
                        :class="cell.selected ? 'selected' : ''"
                        :rowspan="cell.row_span"
                        @mousedown="newDragStart(row, cell, $event)"
                        @mouseover="newDragOver(row, cell, $event)"
                        @mouseup="dragStop(rIdx, cIdx, cell)"
                      >
                        <span v-html="cell.value"></span>
                      </td>
                    </tr>
                  </table>
                </div>
                <br />
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6 pb-4">
          <v-btn @click="editPartDialog.show = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveSectionParts">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editContentDialog.show"
      v-if="editContentDialog.show"
      max-width="1200px"
      scrollable
    >
      <v-card>
        <v-card-title class="d-flex align-center"> </v-card-title>
        <v-card-text style="display: inline-flex">
          <div style="width: 100%">
            <ViewSectionAdmin
              @preview="updateModel"
              :display="'modal'"
              v-if="admin && editingSection"
              @changeRHS="changePanel"
              :workflowConfig="adminConfig"
              :value="editContentDialog.part"
            ></ViewSectionAdmin>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6 pb-4">
          <v-btn @click="editContentDialog.show = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveContentPart">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Notification :notification="notification" />
    <DocumentCompare
      :show="fullCompareView.show"
      :compareList="fullCompareView.items"
      :highlightChanges="fullCompareView.highlightChanges"
      multiDoc fixPrimaryDoc
      showWorkflowActions
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
      @close="fullCompareView.show = false"
    ></DocumentCompare>
    <DocSummary
      :doc_id="documentSummary.doc_id"
      :trigger="documentSummary.trigger"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocSummary>
    <!-- Persistent Content Generation Dialog - eager prop keeps content mounted even when closed -->
    <v-dialog
      v-model="generateContentDialog.show"
      max-width="1200px"
      scrollable
      persistent
      eager
      :retain-focus="false"
    >
      <v-card style="height: 80vh;">
        <v-card-title class="d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon left color="purple">mdi-flask-outline</v-icon>
            AI Content
            <v-chip
              x-small
              outlined
              color="purple"
              text-color="black"
              class="ml-2"
            >
              <span>Beta</span>
            </v-chip>
          </div>
          <v-btn icon @click="generateContentDialog.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height: calc(100% - 64px); overflow: auto;">
          <div
            v-show="showContentGeneration && generateContentData.doc"
            style="height: 100%;"
          >
            <GenerateContent
              ref="generateContentRef"
              :doc="generateContentData.doc"
              :prompt_chain="generateContentData.prompt_chain"
              :isDialog="true"
              @accept="(data) => acceptContentGen(data, true)"
              @statusChange="(status) => generateContentDialog.status = status"
              @executionStarted="handleExecutionStarted"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import viewUtils from "./view/utils";
import ViewSection from "./view/View_Section.vue";
import ViewParts from "./view/View_Parts.vue";
import ViewSectionAdmin from "./view/View_Section_Admin.vue";
import utils from "@/common/utils.js";
import nlpUtils from "@/common/nlpUtils.js";
import draggable from "vuedraggable";
import Notification from "@/components/common/SnackBar.vue";
import SuggestionsPanel from "@/components/common/SuggestionsPanel";
import moment from "moment";
import DataCaptureQuestionnaire from "@/components/cDataCaptureQuestionnaire.vue";
import DataCaptureLevellingEvaluation from "@/components/levellingEvaluation/EvaluationHolder.vue";
import DataCaptureForm from "@/components/cDataCaptureForm.vue";
import DataCaptureRequisitions from "@/components/cDataCaptureRequisitions.vue";
import AssignReviewGroup from "@/components/cAssignReviewGroup.vue";
import ContentDatabase from "@/components/common/ContentDatabase";
import DataCaptureDocumentRole from "@/components/cDataCaptureDocumentRole.vue";
import DocumentComments from "@/components/comments/CommentsContainer";
import ScrollTo from "vue-scrollto";
import DocumentSimilarityPanel from "./DocumentSimilarityPanel.vue";
import DocumentCompare from "@/components/document/DocumentCompare";
import DocSummary from "@/components/common/DocViewPopUp";
import DoughnutChart from "@/components/common/DoughnutChart";
import axios from "axios";
import GenerateContent from "@/components/common/GenerateContent";
import AtlasFlyout from "@/components/agent/AtlasFlyout.vue";
import AtlasSuggestionReview from "@/components/agent/AtlasSuggestionReview.vue";
import {
  useAtlasFlyout,
  registerInlineHost,
  usePageAction,
} from "@/composables/agent/atlasFlyout";
import { getCurrentInstance } from "vue";

export default {
  name: "ViewAdmin",
  /**
   * Bridge to the global Atlas flyout. Two responsibilities:
   *   1. Push the current document into the flyout's page context so
   *      the agent knows what surface it's conversing about. Other
   *      hosts of Document_Holder (side-by-side compare, admin view)
   *      don't set this themselves, and cDocumentFullNEW's write is
   *      harmlessly overwritten by ours since both produce the same
   *      `kind: 'document'` payload shape.
   *   2. Register as an inline Atlas host while mounted so the global
   *      slide-in is hidden — the right-panel "Atlas" tab owns the
   *      surface instead. `open` is also exposed so the Options API
   *      watcher can auto-select the Atlas tab when the user opens
   *      the flyout via the header button (or had it open before
   *      navigating into the doc).
   */
  setup() {
    const flyout = useAtlasFlyout();
    registerInlineHost();

    // Wire the `document.suggest-content` page action to a method on
    // the Options-API instance. The handler can't live in setup()
    // alone because it needs to mutate `data.pendingSuggestions` and
    // call `toggleRHS('atlas')` — both of which are easier to reach
    // through the component proxy than to redeclare via composition
    // primitives.
    const instance = getCurrentInstance();
    usePageAction('document.suggest-content', (payload) => {
      const proxy = instance?.proxy;
      if (!proxy || typeof proxy.beginSuggestionReview !== 'function') return;
      proxy.beginSuggestionReview(payload);
    });

    function setAtlasDocumentContext(reference, docId) {
      const editorEnabled = this.$loginState.user.settings.some(
        (s) => s.setting === "atlas_doc_editor" && s.value === "true");
      if (reference && editorEnabled) {
        flyout.setPageContext({
          kind: 'document',
          summary: `Editing ${reference}`,
          data: {
            reference,
            document_id: docId ?? null,
            mode: 'view-edit',
          },
        }, { overlay: true });
      } else if (reference) {
        // Document open but Atlas doc-editing disabled: hold the clear so
        // the page underneath doesn't restore its own context (see the
        // matching note in cDocumentFullNEW.setAtlasContext).
        flyout.setPageContext(null, { hold: true });
      } else {
        // No document — unmount/clear path; let the host page restore.
        flyout.setPageContext(null);
      }
    }
    function setAtlasOpen(val) {
      if (val) flyout.setOpen();
      else flyout.close();
    }
    return {
      setAtlasDocumentContext,
      setAtlasOpen,
      atlasOpen: flyout.open,
      // True once this document view owns the Atlas context (set by our
      // setAtlasDocumentContext or cDocumentFullNEW's setAtlasContext).
      // mounted() gates its Atlas-tab auto-select on this: before the
      // doc context lands, `atlasOpen` still holds the OUTGOING page's
      // open state (per-context memory restores on context transition),
      // and auto-selecting from that stale value would flash the Atlas
      // tab open and then snap away once the restore runs.
      atlasOverlayOwnsContext: flyout.overlayOwnsContext,
      // Expose the chat messages array so beginSuggestionReview can
      // look up the assistant turn that triggered the review panel.
      // We capture the text at trigger time and show it in the
      // review panel header so the user sees WHY the panel opened.
      atlasMessages: flyout.chat.messages,
    };
  },
  props: {
    displayMethod: String,
    leftPanelContent: String,
    rightPanelContent: String,
    data: null,
    paddingOffset: String,
    disableEdit: Boolean,
    adminMode: Boolean,
    adminConfig: Array,
    readOnly: Boolean,
    dataDrag: Boolean,
    commentsVisible: Boolean,
    isNew: Boolean
  },
  data: function () {
    return {
      moment: moment,
      isLoading: true,
      currentView: null,
      leftPanel: this.leftPanelContent ?? "sections",
      rightPanel: this.rightPanelContent ?? "score",
      rightPanelTab: this.rightPanelContent ?? "score",
      rightPanelHeader: "",
      showLeft: true,
      isWarning: true,
      sectionParts: [],
      bannerText: "",
      footerText: "",
      display: this.displayMethod ?? "full",
      admin: this.adminMode ?? false,
      document: null,
      docStatus: null,
      docHierarchies: null,
      ptDeleteHistory: null,
      partsHistory: null,
      wordChecks: null,
      padOffset: this.paddingOffset ?? "0px",
      disablePartEdit: this.disableEdit ?? false,
      displayFooter: false,
      displayHeader: false,
      navBackDisabled: false,
      navNextDisabled: false,
      navBackHide: false,
      navNextHide: false,
      navChangesHide: false,
      editInProgress: false,
      editingSection: null,
      allSectionList: [],
      currentViewSectionId: 0,
      currentViewSubSectionId: 0,
      sectionCompleteSub: false,
      sectionCompleteLabel: "Complete Sections",
      sectionUnusedParts: [],
      activeSection: null,
      currentReviewSection: [],
      dpScrolled: [],
      templateDefinition: null,
      generateContentData: {
        prompt_chain: null,
        doc: null,
        activeExecution: null, // { executionId, prompt_chain_id, chain_name }
      },
      generateContentDialog: {
        show: false,
        status: 'idle', // 'idle' | 'processing' | 'complete'
        completionViewed: false, // Track if user has viewed the completion
      },
      // Active per-part suggestion review (handed to us by the
      // `document.suggest-content` page action). Non-null while the
      // user is walking through suggestions; cleared on done/cancel.
      // The Atlas tab content swaps from the chat flyout to the
      // review wizard whenever this is populated.
      pendingSuggestions: null,
      // Text of the assistant turn that triggered the active
      // review. Rendered as a chat-bubble header in the review
      // panel so the user has the agent's narration in view —
      // otherwise the panel pops up with no visible link back to
      // the conversation that produced it.
      pendingSuggestionsMessage: null,
      // Set<tp_id> of multi-row parts whose pre-existing rows have already
      // been cleared for a "replace existing" apply in the current review,
      // so we delete them at most once. (Re)initialised per review in
      // beginSuggestionReview.
      suggestionReplaceCleared: null,
      editPartDialog: {
        show: false,
        section_id: 0,
        data: [],
        available: [],
        editMode: "section",
      },
      editContentDialog: {
        show: false,
        part: {},
      },
      dragging: false,
      displayLinkedContent: true,
      saveInProgress: false,
      notification: {
        text: "",
        type: "success",
      },
      allHistory: [],
      history: null,
      checkSummaryPanels: [],
      checkSummaryView: 2,
      checkSummary: [],
      submitAction: null,
      allHistoryData: [],
      documentIssueDisplay: "score_header_only",
      hightLightIssue: null,
      docTitle: null,
      sourceFile: null,
      collabHistory: null,
      comment_doc_part: null,
      comment: {
        dp_id: null,
        part: null,
        partType: null,
        text: "",
        isDirty: false,
        isNew: false,
        tab: null,
      },
      show_lhs_expand: true,
      show_rhs_expand: true,
      lhDrawer: {
        temporary: false,
        defaultShow: false,
        show: false
      },
      rhDefaultShow: false,
      highlightedDocParts: [],
      highlightedDocPartForCommentHover: null,
      highlightedDocPartForCommentFocus: null,
      collaboration: false,
      userSpellCheckEnabled: false,
      nonSuggestionsList: [
        "hdr",
        "header",
        "flex",
        "pattern",
        "logo",
        "bar",
        "intro",
        "social",
      ],
      suggestionPart: null,
      tableDragStart: null,
      tableDragEnd: null,
      tableDragging: false,
      tableDragStartRow: null,
      tableDragStartCell: null,
      tableDragEndRow: null,
      tableDragEndCell: null,
      tableCellRange: {
        rowMin: 0,
        rowMax: 0,
        cellMin: 0,
        cellMax: 0,
        selected: [],
      },
      spellCheckOnLoad: false,
      tableDragSelectedCells: [],
      tableCellHighlightClass: "selectedItem",
      newTableConfig: {
        row_count: 5,
        col_count: 5,
        rows: [
          {
            row_id: 0,
            row_position: 0,
            cells: [
              {
                cell_position: 0,
                row_span: 1,
                col_span: 3,
                selected: false,
                content_type: "static",
                tmpl_part_id: null,
                tpa_id: null,
                tmpl_view_section_content_id: null,
                layout: [],
                display: "text",
                value: "Here is my Table Header",
              },
            ],
          },
          {
            row_id: 1,
            row_position: 1,
            cells: [
              {
                cell_position: 0,
                row_span: 1,
                col_span: 1,
                selected: false,
                content_type: "tmplPart",
                tmpl_part_id: 105004,
                tpa_id: 2442,
                tmpl_view_section_content_id: null,
                layout: [],
                display: "label",
              },
              {
                cell_position: 1,
                row_span: 1,
                col_span: 2,
                selected: false,
                content_type: "tmplPart",
                tmpl_part_id: 105004,
                tpa_id: 2443,
                tmpl_view_section_content_id: null,
                layout: [],
                display: "switch",
              },
            ],
          },
          {
            row_id: 2,
            row_position: 2,
            cells: [
              {
                cell_position: 0,
                row_span: 1,
                col_span: 1,
                selected: false,
                content_type: "static",
                tmpl_part_id: null,
                tpa_id: null,
                tmpl_view_section_content_id: null,
                layout: [],
                display: "text",
              },
              {
                cell_position: 1,
                row_span: 1,
                col_span: 1,
                selected: false,
                content_type: "static",
                tmpl_part_id: null,
                tpa_id: null,
                tmpl_view_section_content_id: null,
                layout: [],
                display: "text",
              },
              {
                cell_position: 2,
                row_span: 1,
                col_span: 1,
                selected: false,
                content_type: "static",
                tmpl_part_id: null,
                tpa_id: null,
                tmpl_view_section_content_id: null,
                layout: [],
                display: "text",
              },
            ],
          },
        ],
      },
      hiddenPartIssueMessage: this.$loginState.user.settings.find(
        (s) => s.setting === "hidden_part_issue_message"
      )?.value ||
        "Issue is in a section of the document not visible to you and can only be rectified by a user with access to that section.",
      skillsLoading: false,
      skillsResponse: {
        Data: [],
        Message: "",
        Status: "OK"
      },
      skillsTab: 0,
      scoreExpanded:true,
      similaritiesExpanded: false,
      fullCompareView: { show: false, highlightChanges: false, items: [] },
      documentSummary: {
        trigger: null,
        doc_id: null,
      },
      docMatches: {
        data: [],
        highlight: false,
        blinking: false,
      },
      partCommentUpdate: null,
      maskedParts: [],
      utils: utils,
    };
  },
  components: {
    ViewSection,
    ViewParts,
    ViewSectionAdmin,
    draggable,
    Notification,
    SuggestionsPanel,
    DataCaptureQuestionnaire,
    DataCaptureLevellingEvaluation,
    DataCaptureForm,
    DataCaptureRequisitions,
    AssignReviewGroup,
    ContentDatabase,
    DataCaptureDocumentRole,
    DocumentComments,
    DocumentSimilarityPanel,
    DocumentCompare,
    DocSummary,
    DoughnutChart,
    GenerateContent,
    AtlasFlyout,
    AtlasSuggestionReview
  },
  watch: {
    data(val) {
      if (val) {
        this.init();
      }
    },
    hierarchiesLoading(val) {
      if (!val) this.init();
    },
    "data.sourceFile"(val) {
      if (val) {
        this.sourceFile = val;
        this.toggleRHS("database");
      }
    },
    "data.document.system_number": {
      immediate: true,
      handler() {
        this.applyAtlasDocumentContext();
      },
    },
    /**
     * Sync the global flyout's `open` state into the right-panel tab
     * selection. Picks up later transitions (header button toggled
     * while the doc is already open); the initial state on mount is
     * handled by the mounted() hook above because Vue 2.7's `immediate:
     * true` doesn't reliably fire for setup-returned refs. Reverse
     * direction (tab click → set open) is handled inside toggleRHS.
     */
    atlasOpen(val) {
      if (val) {
        if (this.rightPanel !== 'atlas') this.toggleRHS('atlas');
      } else if (this.rightPanel === 'atlas') {
        // Header button closed the flyout while the user was on the
        // Atlas tab — fall back to the default tab.
        this.toggleRHS(this.showScoring ? 'score' : 'database');
      }
    },
    leftPanelContent(val) {
      if (val === "gutter") {
        this.showLeft = false;
      }
      this.leftPanel = val;
    },
    rightPanelContent(val) {
      this.rightPanel = val;
    },
    rightPanelTab(val) {
      // Mark completion as viewed and clear active execution when content gen tab becomes visible
      if (val === 'contentGen') {
        if (this.generateContentDialog.status === 'complete') {
          this.generateContentDialog.completionViewed = true;
          this.generateContentDialog.status = 'idle';
          this.generateContentData.activeExecution = null;
          if (this.generateContentData.doc) {
            this.generateContentData.doc.active_generation = null;
          }
        }
      }
    },
    dataDrag(val) {
      this.dragging = val;
    },
    "data.showComments"(val) {
      if (val) {
        if (this.showScoring)
          this.toggleRHS("score");
        else
          this.toggleRHS("comments");
      }
    },
    commentsVisible(val) {
      if (this.showAllComments && this.canViewComments) {
        if (!val) {
          this.toggleRHS("");
          this.resetSectionForComment();
        } else
          this.toggleRHS("all-comments");
      }
    },
    'data.document.commentsVisible'() {
      if (this.showAllComments && this.canViewComments) {
        if (this.rightPanel === "all-comments")
          this.toggleRHS("");
        else
          this.toggleRHS("all-comments");
      }
    },
    'data.document.matches'() {
      this.refreshDocMatches();
    },
    editInProgress() {
      this.refreshDocMatches();
    },
    'lhDrawer.show'(val) {
      if (val)
        this.toggleLHS('sections');
      else
        this.toggleLHS('gutter');
    }
  },
  computed: {
    isDemo() {
      return this.$loginState.user?.client?.endsWith('Demo');
    },
    /**
     * Part groups in the active review where the wizard offers a "delete
     * the rows not in this set" option — used to turn a reduce/combine
     * request (e.g. "combine 10 requirements into 6") into a true
     * replacement. A group qualifies when the AGENT flagged it
     * (`replace_existing: true` on its suggestions — the only reliable
     * intent signal; the model may express the consolidation as updates
     * OR new rows, and a plain "add a row" must NOT trigger deletion), it
     * targets a MULTI-ROW part, and there are existing rows the set
     * doesn't cover. `count` is how many rows would be removed — active
     * rows NOT targeted by a suggestion in this review (rows being updated
     * in place are kept). Recomputes as rows are created/deleted, so the
     * option disappears once the leftover rows are gone.
     */
    suggestionReplaceTargets() {
      if (!Array.isArray(this.pendingSuggestions)) return [];
      const out = [];
      const seen = new Set();
      for (const s of this.pendingSuggestions) {
        const tpId = s.tp_id;
        if (tpId == null || seen.has(tpId)) continue;
        const flagged = this.pendingSuggestions.some(
          (x) => x.tp_id === tpId && x.replace_existing === true,
        );
        if (!flagged) continue;
        const pt = this.findPartType(tpId, this.data?.document?.parttypes);
        if (!pt || !(pt.multi_row || pt.tmpl_part_metadata?.multi_row)) {
          continue;
        }
        const preserve = new Set(
          this.pendingSuggestions
            .filter((x) => x.tp_id === tpId && x.doc_part_id)
            .map((x) => Number(x.doc_part_id)),
        );
        const existing = (pt.parts || []).filter(
          (p) => p.doc_part_id > 0 && !preserve.has(p.doc_part_id),
        );
        if (existing.length === 0) continue;
        seen.add(tpId);
        out.push({
          tp_id: tpId,
          label: s.part_label || pt.type || 'rows',
          count: existing.length,
        });
      }
      return out;
    },
    showSuggestions() {
      return !this.activeSection || this.activeSection.show_suggestions;
    },
    showContentGeneration() {
      const settingEnabled = this.$loginState.user.settings.some((s) => s.setting === "content_generation_document" && s.value === "true");
      let rolesAllowed = this.$loginState.user.settings.find(x => x.setting === 'content_generation_document_roles');

      if(settingEnabled){
        let adminRoles = ["RoleMapper Admin"];
        if(rolesAllowed) { adminRoles = rolesAllowed.value.split("|"); }
        if(this.$loginState.user.permission_groups.some(x => adminRoles.includes(x))){
          return true;
        }
      }

      return false;
    },    
    showRHSTabs() {
      const visibleTabs = (this.showScoring ? 1 : 0)
        + (this.showSuggestions ? 1 : 0)
        + 1 // database tab is always visible
        + 1 // atlas tab is always visible
        + (this.showSkillsPanel ? 1 : 0)
        + (this.showAllComments && this.canViewComments ? 1 : 0);
      return visibleTabs > 1 //only visible tab is database
        && ['score', 'suggestions', 'skills', 'database', 'all-comments', 'contentGen', 'atlas'].includes(this.rightPanel);
    },
    showSimilaritiesPanel(){
      return this.config.settings.some(
          (s) => s.setting === 'document_show_similarities' && s.value === "true"
      );
    },   
    showAllComments(){
      return this.config.settings.some(
          (s) => s.setting === 'document_show_all_comments' && s.value === "true"
      );
    },   
    showRHSExpansionHeaders(){
      // if(this.showSimilaritiesPanel){
      //   return true;
      // }
      return false;
    }, 
    ...mapState({
      config: (state) => state.settings.config,
      newUi: (state) => state.theme.newUi,
      docsLoading: (state) => state.docs.loading,
      docStatusSummary: (state) => state.docs.docStatusSummary,
      docTypeSummary: (state) => state.docs.docTypeSummary,
      hierarchiesLoading: (state) => state.hierarchies.loading,
      docTypes: (state) => state.hierarchies.docTypes,
      docListColumns: (state) => state.settings.config.docListColumns,
      lifecycleStatuses: (state) => state.hierarchies.lifecycleStatuses,
    }),
    leftPanelWidth() {
      if (this.display === "sidebysidefull") {
        return "0px";
      }
      if (!this.show_lhs_expand) {
        return "42px";
      }
      switch (this.leftPanel) {
        case "gutter":
          return "42px";
        case "sections":
        default:
          return "232px";
      }
    },
    rightPanelWidth() {
      if (this.display === "sidebysidefull") {
        return this.rightPanel === 'all-comments' ? "400px" : "0px";
      }
      switch (this.rightPanel) {
        case "permissions":
          return "350px";
        case "partPermissions":
          return "850px";
        case "hidden":
          return "10px";
        case "suggestions":
          return "375px";
        case "skills":
          return "375px";
        case "contentGen":
        case "database":
        case "DCE":
        case "atlas":
          return "min(40%, 750px)";
        case "history":
        case "allHistory":
        case "score":
        case "comments":
          return "400px";
        case "all-comments":
          return "430px";
        case "collaboration":
        default:
          return "245px";
      }
    },
    containerHeight() {
      if (this.display === "sidebysidefull") {
        return  "93px";
      } else
        return this.display === "modal" ? "0px" : "48px";
    },
    headerHeight() {
      if (this.display === "sidebysidefull") {
        return  "93px";
      } else
        return this.display === "modal" ? "0px" : "48px";
    },
    containerPaddingTop() {
      return this.displayHeader ? "0px" : "64px";
    },
    docContentBannerHeight() {
      return this.displayHeader ? "60px" : "10px";
    },
    docContentFooterHeight() {
      return this.displayFooter ? "60px" : "10px";
    },
    topPadOffset() {
      return this.padOffset;
    },
    displayModeTopPad() {
      return this.display === "modal" ? "64px" : "0px";
    },
    contentWidth() {
      return "100%"; //this.display === "sidebysidefull" ? "100%" : "100vw";
    },
    cssVars() {
      return {
        //width of left panel content
        "--left-panel-width": this.leftPanelWidth,
        "--left-panel-space": this.lhDrawer.temporary ? '42px' : this.leftPanelWidth,
        //width of right panel content
        "--right-panel-width": this.rightPanelWidth,

        "--container-height": this.containerHeight,
        //height of app bar header in full view/doc modal
        "--header-height": this.headerHeight,
        //padding to top of content based on header
        "--padding-top": this.containerPaddingTop,
        "--doc-banner-height": this.docContentBannerHeight,
        "--doc-footer-height": this.docContentFooterHeight,
        "--container-top-offset": this.topPadOffset,
        "--display-mode-topPadding": this.displayModeTopPad,
        "--content-width": this.contentWidth,
      };
    },
    partOrderedList() {
      let itemsClone = [...this.editPartDialog.data];
      let data = itemsClone
        .filter((x) => x.order)
        .sort((a, b) => a.order - b.order);
      return data;
    },
    docTitleList() {
      if (this.data.document) {
        return [
          {
            doc_name: this.data.document.doc_name,
            doc_id: this.data.document.doc_id,
          },
        ];
      }

      return [];
    },
    suggestionsData() {
      if (this.suggestionPart) {
        return {
          doc_id: this.document.doc_id,
          type: this.suggestionPart.type,
          tmpl_part_id: this.suggestionPart.tmpl_part_id,
          attr_id: this.suggestionPart.attr_id,
          dp_id: this.suggestionPart.dp_id,
          multiple:
            this.suggestionPart.multi_row ||
            this.suggestionPart.tmpl_part_metadata?.multi_row,
        };
        // }
        // if(this.sectionParts){
        //     let allParts = this.sectionParts.filter(x => x.tmpl_part_id && !this.nonSuggestionsList.some(v => x.type.toLowerCase().includes(v))).map(x => {
        //         return {
        //             tmpl_part_id: x.tmpl_part_id,
        //             type: x.type,
        //             multiple: (x.cardinality.maxError > 1 || x.cardinality.minError > 1 || x.cardinality.maxWarn > 1 || x.cardinality.minWarn > 1)
        //         }
        //     });

        //     return this.suggestionPart === "" ? allParts : allParts.filter(x => x.type === this.suggestionPart);
      } else {
        return null;
      }
    },
    sectionPermissionList() {
      return this.activeSection ? this.activeSection.permissions_list : null;
    },
    showScoring() {
      return (
        !!this.data.document.state.showActions?.some((x) => x.showScoring) &&
        !this.isTranslated
      );
    },
    canViewComments() {
      return !!this.data.document.state.docPartCommentAction || this.data.document.state.showActions.some(x => x.showDocumentComments);
    },
    isTranslated() {
      return (
        this.data.document.language_code !== null &&
        this.data.document.language_code !== "en"
      );
    },
    showSkillsPanel(){
      return false;
      /*return this.$loginState.user.settings.some(
          (s) => s.setting === 'roleskill_module' && s.value === "true"
      );*/
    },   
    activeSummaryCategories() {
      return this.checkSummary?.categories.filter(c => c.score != '100') || [];
    },
  },
  mounted() {
    // If Atlas was open for THIS document's context when it was last
    // viewed (per-context open memory restores it the moment our
    // context lands), surface the inline Atlas tab immediately. The
    // `atlasOpen` watcher below handles transitions that happen later
    // (header button click while in-doc, or the context/restore landing
    // after an async doc load), but Vue 2.7's Options API `immediate:
    // true` doesn't reliably fire for setup-returned refs before data()
    // finishes — checking from mounted() gives us a deterministic
    // ordering.
    //
    // Gated on `atlasOverlayOwnsContext`: until this document view owns
    // the Atlas context, `atlasOpen` is still the previous page's state
    // and must not drive the tab.
    if (
      this.atlasOpen &&
      this.atlasOverlayOwnsContext &&
      this.rightPanel !== 'atlas'
    ) {
      this.toggleRHS('atlas');
    }
  },
  updated() {},
  created() {
    this.init();
  },
  methods: {
    openContentGenerationDialog() {
      this.generateContentDialog.show = true;

      // Activate the GenerateContent component if it hasn't been activated yet
      this.$nextTick(() => {
        if (this.$refs.generateContentRef) {
          // If there's an active execution, resume it
          if (this.generateContentData.activeExecution?.executionId) {
            if (this.$refs.generateContentRef.resumeActiveGeneration) {
              console.log('Resuming active execution:', this.generateContentData.activeExecution.executionId);
              this.$refs.generateContentRef.resumeActiveGeneration(
                this.generateContentData.activeExecution.executionId
              );
            }
          } else if (this.$refs.generateContentRef.activate) {
            // Otherwise, just activate normally
            this.$refs.generateContentRef.activate();
          }
        }
      });
    },
    acceptContentGen(data, dialog){
      let dataRequest = {
        system_reference: this.data.document.system_number,
        populatedData: data.populatedData,
        hierarchies:  data.hierarchies,
        viewAction: this.data.document.viewAction,
        update_deleteList: true
      }
      this.saveStart();
      if(dialog){
        this.generateContentDialog.show = false;
      }

      // Clear active execution and completion state since content was accepted
      this.generateContentData.activeExecution = null;
      this.generateContentDialog.completionViewed = false;
      if (this.generateContentData.doc) {
        this.generateContentData.doc.active_generation = null;
      }

      this.maskedParts = data.populatedData.map(x => x.tmpl_part_id);
      axios
        .post("document/updateDocument", dataRequest)
        .then((resp) => {
          this.$emit("reloadDocument", resp.data.Data);
          this.saveEnd();
          this.maskedParts = [];
        })
        .catch((error) => {
          this.saveEnd();
          this.maskedParts = [];
        });
    },
    handleExecutionStarted(executionData) {
      // Store the active execution info so we can restore it when switching tabs
      this.generateContentData.activeExecution = {
        executionId: executionData.executionId,
        prompt_chain_id: executionData.prompt_chain_id,
        chain_name: executionData.chain_name,
        doc_id: this.generateContentData.doc?.doc_id,
        isRegeneration: executionData.isRegeneration || false,
        isPartial: executionData.isPartial || false
      };

      // Set active_generation on doc so GenerateContent can auto-resume on init
      if (this.generateContentData.doc) {
        this.generateContentData.doc.active_generation = executionData.executionId;
      }

      // Reset completion viewed flag for new execution
      this.generateContentDialog.completionViewed = false;

      console.log('Active execution tracked:', this.generateContentData.activeExecution);
    },
    quickView(id, event){
      this.documentSummary.doc_id = id;
      this.documentSummary.trigger = event;
    },
    initCompare(data){

      let allList = [
        {
          doc_id: this.document.doc_id,
          isCurrentDoc: true,
        },
        ...data
      ];
      let compareList = allList.map(d => {
        if (typeof d === "object")
          return d;
        else
          return { doc_id: d }
      });
      
      this.fullCompareView.items = compareList;
      this.fullCompareView.show = true;
    },
    openDocument(item) {
      if (!item.system_number) return;

      this.$emit("openDocument", {
        system_number: utils.removeTags(item.system_number),
        doc_name: utils.removeTags(item.doc_name),
        doc_type: item.doc_type,
        viewAction: item.viewAction,
      });
    },
    /**
     * "Open" from the inline Atlas tab's chat cards, when no
     * document.open page action was registered. The flyout's doc refs
     * carry `reference` (RM-x) where grid rows carry `system_number` —
     * map and reuse the standard openDocument emit.
     */
    openAtlasDocument(doc) {
      if (!doc || !doc.reference) return;
      this.openDocument({
        system_number: doc.reference,
        doc_name: doc.doc_name || "",
        doc_type: doc.doc_type,
      });
    },
    autoCollapseSidePanels(init) {
      if (this.admin) {
        this.lhDrawer.temporary = false;
        this.lhDrawer.show = true;
        return;
      }

      const lhBreakpoint = 1400;
      const rhBreakpoint = 1200;
      const width = window.innerWidth;
      if (!width)
        return;

      if (this.show_lhs_expand && width < lhBreakpoint && (!this.lhDrawer.temporary || init === true)) {
        this.lhDrawer.temporary = true;
        this.lhDrawer.show = false;
      } else if (this.show_lhs_expand && width > lhBreakpoint && (this.lhDrawer.temporary || init === true)) {
        this.lhDrawer.temporary = false;
        this.lhDrawer.show = this.lhDrawer.defaultShow;
        if (!this.lhDrawer.show)
          this.toggleLHS('gutter');
      }

      if (this.show_rhs_expand && width < rhBreakpoint && this.rightPanel !== 'hidden') {
        this.toggleRHS('hidden');
      } else if (this.show_rhs_expand && width > rhBreakpoint && this.rightPanel === 'hidden') {
        this.toggleRHS(this.rhDefaultShow ? 'score' : 'hidden');
      }
    },
    getSkills(){
      this.skillsLoading = true;
      let data = {
        doc_id: this.document.doc_id,
        system_number: this.document.system_number
      }
			axios  
				.post("skills/getSkills", data)
				.then((resp) => {
          this.skillsResponse = resp.data;
          this.skillsLoading = false;
				})
				.catch((error) => {
          console.log(error);
          this.skillsLoading = false;
				});
    },
    closeSuggestionsPanel() {
      this.toggleRHS("score");
    },
    syncViewPositions(item) {
      let options = {
        container: this.docHolderCenterElementId(true),
        easing: "ease-in",
        offset: -20,
        force: true,
        cancelable: true,
        x: false,
        y: true,
      };
      ScrollTo.scrollTo(
        `#viewcontainer_${this.document.doc_id}_${item
          .replace(/\s+/g, "")
          .replace(/'+/g, "")}`,
        500,
        options
      );
    },
    syncPosition(item) {
      this.$emit("syncPositions", item);
    },
    hierarchyUpdated(data) {
      this.$emit("hierarchyUpdated", data);
    },
    multiRowPart(item) {
      return item.multi_row || item.tmpl_part_metadata?.multi_row;
    },
    baseCell() {
      return {
        cell_position: 0,
        row_span: 1,
        col_span: 1,
        selected: false,
        content_type: "static",
        tmpl_part_id: null,
        tpa_id: null,
        tmpl_view_section_content_id: null,
        layout: [],
        display: "text",
      };
    },
    generateTable() {
      this.newTableConfig.rows = [];
      for (var i = 0; i < this.newTableConfig.row_count; i++) {
        let rowObj = {
          row_id: 0,
          row_position: i,
          cells: [],
        };
        for (var x = 0; x < this.newTableConfig.col_count; x++) {
          let cell = {
            ...this.baseCell(),
            cell_position: x,
          };
          rowObj.cells.push(cell);
        }
        this.newTableConfig.rows.push(rowObj);
      }
    },
    newSelectTo(row, cell) {
      let startRow =
        this.tableDragStartRow.row_position +
        (this.tableDragStartCell.row_span - 1);
      let startCell =
        this.tableDragStartCell.cell_position +
        (this.tableDragStartCell.col_span - 1);

      let endRow =
        this.tableDragEndRow.row_position +
        (this.tableDragEndCell.row_span - 1);
      let endCell =
        this.tableDragEndCell.cell_position +
        (this.tableDragEndCell.col_span - 1);

      var rowStart, rowEnd, cellStart, cellEnd;

      if (endRow <= startRow) {
        rowStart = row;
        rowEnd =
          this.tableDragStartRow.row_position +
          (this.tableDragStartCell.row_span - 1);
      } else {
        rowStart =
          this.tableDragStartRow.row_position +
          (this.tableDragStartCell.row_span - 1);
        rowEnd = row;
      }

      if (endCell <= startCell) {
        cellStart = cell;
        cellEnd =
          this.tableDragStartCell.cell_position +
          (this.tableDragStartCell.col_span - 1);
      } else {
        cellStart =
          this.tableDragStartCell.cell_position +
          (this.tableDragStartCell.col_span - 1);
        cellEnd = cell;
      }

      console.log(rowStart, rowEnd, cellStart, cellEnd);
      this.clearSelected();

      this.tableCellRange = {
        rowMin: rowStart,
        rowMax: rowEnd,
        cellMin: cellStart,
        cellMax: cellEnd,
        selected: [],
      };

      this.newTableConfig.rows.forEach((r) => {
        r.cells.forEach((c) => {
          let matchRow = r.row_position >= rowStart && r.row_position <= rowEnd;
          let matchCell =
            c.cell_position >= cellStart && c.cell_position <= cellEnd;

          if (matchRow && matchCell) {
            c.selected = true;
            this.tableCellRange.selected.push(c);
          }
        });
      });

      /*for (var i = startCellRowSpan; i <= endRow; i++) {
                for (var j = startCellColSpan; j <= endCell; j++) {
                    this.newTableConfig.rows[i].cells[j].selected = true;
                }  
            }*/

      /*var rowStart, rowEnd, cellStart, cellEnd;
    
            if (rowIdx < this.tableDragStartRow) {
                rowStart = rowIdx;
                rowEnd = this.tableDragStartRow;
            } else {
                rowStart = this.tableDragStartRow;
                rowEnd = rowIdx;
            }
            
            if (cellIdx < this.tableDragStartCell) {
                cellStart = cellIdx;
                cellEnd = this.tableDragStartCell;
            } else {
                cellStart = this.tableDragStartCell;
                cellEnd = cellIdx;
            }    */
    },
    newDragOver(row, cell, ev) {
      if (!this.tableDragStart) return;
      ev.preventDefault();
      ev.stopPropagation();
      this.tableDragEndRow = row;
      this.tableDragEndCell = cell;
      let endRow = row.row_position + (1 - cell.row_span);
      let endCell = cell.cell_position + (1 - cell.col_span);
      this.newSelectTo(endRow, endCell);
      return false;
    },
    newDragStart(row, cell, ev) {
      this.tableDragStart = true;
      this.tableDragStartCell = cell;
      this.tableDragStartRow = row;
      ev.preventDefault();
      ev.stopPropagation();
      this.clearSelected();
      return false;
    },
    dragStop() {
      this.tableDragStart = false;
    },
    selectTo(rowIdx, cellIdx) {
      var rowStart, rowEnd, cellStart, cellEnd;

      if (rowIdx < this.tableDragStartRow) {
        rowStart = rowIdx;
        rowEnd = this.tableDragStartRow;
      } else {
        rowStart = this.tableDragStartRow;
        rowEnd = rowIdx;
      }

      if (cellIdx < this.tableDragStartCell) {
        cellStart = cellIdx;
        cellEnd = this.tableDragStartCell;
      } else {
        cellStart = this.tableDragStartCell;
        cellEnd = cellIdx;
      }

      this.clearSelected();

      this.tableCellRange = {
        rowMin: rowStart,
        rowMax: rowEnd,
        cellMin: cellStart,
        cellMax: cellEnd,
      };

      this.newTableConfig.rows.forEach((r, ridx) => {
        r.cells.forEach((c, cidx) => {
          let rowspan = ridx + (c.row_span - 1);
          let cellspan = cidx + (c.col_span - 1);

          if (
            ridx >= rowStart &&
            rowspan <= rowEnd &&
            cellspan <= cellEnd &&
            cidx >= cellStart
          ) {
            c.selected = true;
          }
        });
      });

      /*this.newTableConfig.rows.forEach((r,ridx) => {
                if((ridx+(r.row_span - 1)) <= rowEnd){
                    r.cells.forEach((c,cidx) => {
                        if((cidx+(c.col_span - 1)) <= cellEnd){
                            c.selected = true;
                        }
                    })
                }
            })*/

      /*for (var i = rowStart; i <= rowEnd; i++) {
                for (var j = cellStart; j <= cellEnd; j++) {
                    this.newTableConfig.rows[i].cells[j].selected = true;
                }  
            }   */
    },
    clearSelected() {
      this.newTableConfig.rows.forEach((r) => {
        r.cells.forEach((c) => {
          c.selected = false;
        });
      });
    },
    dragOver(rowIdx, cellIdx, ev) {
      if (!this.tableDragStart) return;
      ev.preventDefault();
      ev.stopPropagation();
      this.tableDragEndRow = rowIdx;
      this.tableDragEndCell = cellIdx;
      this.selectTo(rowIdx, cellIdx);
      return false;
    },
    setStartCell(rowIdx, cellIdx, ev) {
      this.tableDragStart = true;
      this.tableDragStartCell = cellIdx;
      this.tableDragStartRow = rowIdx;
      /*if(this.newTableConfig.rows[rowIdx].cells[cellIdx].row_span > 1){
                this.tableDragStartRow = this.newTableConfig.rows[rowIdx].cells[cellIdx].row_span - 1;
            }

            if(this.newTableConfig.rows[rowIdx].cells[cellIdx].col_span > 1){
                this.tableDragStartCell = this.newTableConfig.rows[rowIdx].cells[cellIdx].col_span - 1;
            }*/
      ev.preventDefault();
      ev.stopPropagation();
      return false;
    },
    async doReviewRevert(data) {
      if (!data) return;
      if (!data.processed)
        await this.reviewRevert(data.rc, data.part, data.partType);
      data.processed = true;
    },
    async reviewRevert(change, part) {
      this.revertAttributes(part.attributes, change.attributes);
      let changes = [
        { column: "text", oldValue: change.previous },
        { column: "is_essential", oldValue: change.previous_is_essential },
      ];
      let obj = {
        ...part,
        changes: changes,
      };
      await this.revertChange(obj);
    },
    revertAttributes(original, updates) {
      original.forEach((a) => {
        let updated = updates.find((c) => c.tpa_id === a.tpa_id);
        if (updated && a.text !== updated.text) {
          a.text = updated.text;
          a.isDirty = true;
        }
      });
    },
    // instantiateNewRow(partType, parent, text = "") {
    //     let currentParts = (parent ? parent.childParts : partType.parts).filter(
    //         (x) => x.tmpl_part_id === partType.tmpl_part_id
    //     );
    //     let sequence = currentParts.length
    //         ? currentParts.reduce(
    //             (pval, cval) => (pval > cval.sequence ? pval : cval.sequence),
    //             0
    //         ) + 1
    //         : 1;
    //     let ret = {
    //         Status: "",
    //         StatusList: [],
    //         WordCount: "",
    //         doc_part_id: 0,
    //         id: "",
    //         notes: "",
    //         isDirty: false,
    //         rowMessage: "",
    //         sequence: sequence,
    //         status: "",
    //         text: text,
    //         is_essential:
    //         partType.tmpl_part_metadata.uses_essential_flag === 2
    //             ? this.tempEssentials
    //             ? null
    //             : 1
    //             : 0,
    //         attributes: [],
    //         quality: 0,
    //         type: partType.type,
    //         tmpl_part_id: partType.tmpl_part_id,
    //         parent_dp_id: parent ? parent.doc_part_id : null,
    //         highlightSection: false,
    //         editing: false,
    //         hover: false,
    //         moveable: partType.tmpl_part_metadata.moveable,
    //         expanded: false,
    //         linked_content: []
    //     };
    //     if (partType.tmpl_part_metadata.attributes.length) {
    //         ret.attributes = partType.tmpl_part_metadata.attributes.map((a) => {
    //         return {
    //             dpa_id: 0,
    //             tpa_id: a.tpa_id,
    //             text: text,
    //             editing: false,
    //             isDirty: true,
    //             active: true,
    //             cols: a.cols,
    //             restrict_to_lookup: a.restrict_to_lookup,
    //             rank_attribute: a.rank_attribute,
    //             placeholder: a.placeholder,
    //             restrict_to_date: a.restrict_to_date,
    //             locked: a.locked,
    //             css_class_name: a.css_class_name,
    //             allow_adding: a.allow_adding,
    //             lookup_type: a.lookup_type,
    //             lookup_key: a.lookup_key,
    //             restrict_to_htid: a.restrict_to_htid,
    //             restrict_to_ht_level: a.restrict_to_ht_level,
    //             tag_type_id: a.tag_type_id,
    //         };
    //         });
    //     } else {
    //         ret.attributes.push({
    //             active:true,
    //             allow_adding:true,
    //             cols:12,
    //             css_class_name:"",
    //             default_text: partType.tmpl_part_metadata.default_text ?? "",
    //             editing: false,
    //             isDirty: true,
    //             include_in_part_val:true,
    //             locked: partType.tmpl_part_metadata.tp_locked === 1,
    //             lookup_dependency_tpa_source:null,
    //             lookup_key:null,
    //             lookup_type:null,
    //             lookup_v2_tpa_destination:null,
    //             lookup_v3_tpa_destination:null,
    //             position:1,
    //             prefix:null,
    //             required:null,
    //             restrict_to_date:null,
    //             restrict_to_lookup:null,
    //             rank_attribute:null,
    //             separator:null,
    //             suffix:null,
    //             text: text,
    //             title:null,
    //             tpa_id:null,
    //             restrict_to_htid: 0,
    //             restrict_to_ht_level: 0,
    //             tag_type_id: null,
    //         });
    //     }

    //     if (partType.childPartTypes && partType.childPartTypes.length) {
    //         ret.childParts = [];
    //         utils.setupChildPartTypes(
    //         ret,
    //         partType,
    //         this.data.partsHistory,
    //         this.data.docHierarchies,
    //         this.data.wordChecks
    //         );
    //     }
    //     utils.setDocPartStatus(
    //         ret,
    //         partType,
    //         this.data.wordChecks,
    //         this.data.docStatus,
    //         this.data.document
    //     );

    //     if (parent !== undefined && parent.temp === true) {
    //         ret.temp = true;
    //     }

    //     return ret;
    // },
    async revertDelete(item) {
      this.saveStart();
      let partType = this.ptDeleteHistoryPT;
      let data = {
        doc_part_id: item.key,
        sequence: partType.parts.length + 1,
        doc_part_type: partType.type,
        tmpl_part_id: partType.tmpl_part_id,
      };

      let result = await viewUtils.revertDeletePart(data);

      let row = viewUtils.instantiateNewRow(
        partType,
        undefined,
        result.data.Data.newRow.text
      );

      if (result.data.Data.newRowAttributes.length > 0) {
        row.attributes = row.attributes.map((ra) => {
          let match = result.data.Data.newRowAttributes.find(
            (x) => x.tpa_id === ra.tpa_id
          );
          return {
            ...ra,
            dpa_id: match?.dpa_id,
            text: match?.value,
          };
        });
      }

      let obj = {
        ...row,
        ...result.data.Data.newRow,
        doc_part_id: item.key,
        doc_part_type: partType.type,
        tmpl_part_id: partType.tmpl_part_id,
        parent_dp_id: parent ? parent.doc_part_id : null,
        sequence: row.sequence,
        insertOrder: row.sequence,
      };

      this.ptDeleteHistory;
      await this.updatePart({ part: obj, response: { result: result.data } });
      this.saveEnd();
      this.triggerNotification(`${partType.type} Reverted`, "success");

      let phIndex = this.partsHistory.findIndex((ph) => ph.key === item.key);
      if (phIndex >= 0) {
        this.partsHistory.splice(phIndex, 1);
      }
      this.partsHistory.push(result.data.Data.audit);

      let dhIndex = this.ptDeleteHistory.findIndex((ph) => ph.key === item.key);
      if (dhIndex >= 0) {
        this.ptDeleteHistory.splice(dhIndex, 1);
      }
      partType.hasDeletedParts = this.partsHistory.some(
        (pa) => pa.isDeleted && pa.name === partType.type
      );
    },
    async revertChange(item) {
      this.saveStart();
      let docpart = this.history.part;
      let obj = {
        text: null,
        is_essential: null,
        notes: null,
        quality: null,
        attributes: item.oldAttributes || [],
      };
      if (obj.attributes.length) {
        this.revertAttributes(docpart.attributes, obj.attributes);
      }
      item.changes?.forEach((c) => {
        obj[c.column] = c.oldValue;
      });

      const findPartType = (tmplPartId, partTypes) => {
        let ptFound = null;
        for (let pt of partTypes) {
          if (pt.tmpl_part_id === tmplPartId) {
            ptFound = pt;
            break;
          } else if (pt.childPartTypes) {
            const childPt = findPartType(tmplPartId, pt.childPartTypes);
            if (childPt) {
              ptFound = childPt;
              break;
            }
          }
        }
        return ptFound;
      };

      let docPartType = findPartType(docpart.tmpl_part_id, this.data.document.parttypes);
      let isAttr = docPartType?.tmpl_part_metadata?.attributes?.length >= 2;

      let newObj = {
        text: obj.text === null ? docpart.text : obj.text,
        doc_part_id: docpart.doc_part_id,
        doc_part_type: docPartType?.type,
        doc_id: this.data.document.doc_id,
        system_number: this.data.document.system_number,
        tmpl_part_id: docpart.tmpl_part_id,
        notes: obj.notes === null ? docpart.notes : obj.notes,
        parent_dp_id: null,
        is_essential:
          obj.is_essential === null ? docpart.is_essential : obj.is_essential,
        quality: docpart.quality,
        sequence: docpart.sequence,
        attributes: isAttr ? docpart.attributes : [],
      };

      docpart = {
        ...docpart,
        text: newObj.text,
        notes: newObj.notes,
        is_essential: newObj.is_essential,
      };

      docpart.subParts = isAttr
        ? utils.attributesToText(
            docPartType.tmpl_part_metadata.attributes,
            docpart.attributes
          )
        : utils.partToSubParts(docpart.text);
      if (docpart.attributes.length === 1) {
        docpart.attributes[0].text = docpart.text;
      }

      let result = await viewUtils.updateDocPart(newObj);

      await this.updatePart({ part: docpart, response: result });
      this.saveEnd();
      this.triggerNotification(`${docPartType?.type ?? 'Change'} Reverted`, "success");
    },
    openSuggestions(part) {
      this.suggestionPart = part;

      if (this.display === "sidebysidefull") {
        this.$emit("openSuggestions", part);
        return;
      }
      if (this.rightPanel === "score" || this.rightPanel === "suggestions") {
        this.toggleRHS("suggestions");
      }
    },
    updateRecentPart(part) {
      this.suggestionPart = part;
      if (this.display === "sidebysidefull") {
        this.$emit("openSuggestions", part);
        return;
      }
    },
    initDrag() {
      this.dragging = true;
    },
    dragEnd() {
      this.dragging = false;
    },
    // commentHandler(action) {
    //   switch (action) {
    //     case "save_new":
    //       this.doStateActionComment(
    //         this.data.document.state.docPartCommentAction,
    //         this.comment
    //       );
    //       break;
    //     case "cancel_new":
    //       this.comment.text = "";
    //       this.comment.isDirty = false;
    //       break;
    //   }
    // },
    updateQuestionnaireAnswer(qa) {
        this.$emit("updateQuestionnaireAnswer", qa);
    },
    doStateAction(a) {
        this.$emit("doStateAction", a);
    },
    // async doStateActionComment(action, comment) {
    //   if (!this.data.document) return;
    //   this.isLoading = true;
    //   let saveRespHandler = (data) => {
    //     this.commentHandler("cancel_new");
    //     if (data) {
    //       if (this.comment.part) this.comment.part.hasComments = 1;
    //       let newComment = data.comments[0];
    //       this.history.collabSummary.unshift({
    //         type: "comment",
    //         sortBy: null,
    //         user_name: newComment.user_name,
    //         user_initials: newComment.user_initials,
    //         data: data.comments[0],
    //       });
    //     }
    //   };
    //   let request = {
    //     doc_id: this.data.document.doc_id,
    //     action_available_id: action.action_available_id,
    //     lifecycle_role_id: action.lifecycle_role_id,
    //     document_role_id: action.document_role_id,
    //     preProcessResponse: null,
    //     comment: comment,
    //   };

    //   await viewUtils.processdocumentaction(request).then((resp) => {
    //     if (resp.data.Status === "OK") {
    //       saveRespHandler(resp.data.Data);
    //     } else {
    //       alert(resp.data.Message);
    //     }
    //     this.isLoading = false;
    //   });
    // },
    // NOT CALLED - JW
    // handleDelete(row, partType, parent, resp, source) {
    //     row.isDirty = false;
    //     let pts = (parent ? parent.childPartTypes : source).find(
    //         (pt) => pt.type === partType.type
    //     );
    //     if (pts && pts.parts) {
    //         let pIndex = pts.parts.findIndex(
    //         (p) => p.doc_part_id === row.doc_part_id
    //         );
    //         if (pIndex >= 0) {
    //         // won't be present if moved
    //         pts.parts.splice(pIndex, 1);
    //         }
    //     }
    //     if (parent) {
    //         let cIndex = parent.childParts.findIndex(
    //         (p) => p.doc_part_id === row.doc_part_id
    //         );
    //         if (cIndex >= 0) parent.childParts.splice(cIndex, 1);
    //         if (!parent.childParts.length) {
    //         parent.expanded = false;
    //         }
    //     }
    //     partType.parts.forEach((p) => {
    //         utils.setDocPartStatus(
    //         p,
    //         partType,
    //         this.data.wordChecks,
    //         this.data.docStatus,
    //         this.data.document
    //         );
    //     });

    //     let phIndex = this.partsHistory.findIndex(
    //         (ph) => ph.key === row.doc_part_id
    //     );
    //     if (phIndex >= 0) {
    //         if (this.history && this.history.key === row.doc_part_id) {
    //           this.toggleRHS('score')
    //           this.history = null;
    //         }
    //         this.partsHistory.splice(phIndex, 1);
    //     }
    //     if (resp && resp.data && resp.data.Data && resp.data.Data.audit) {
    //         this.partsHistory.push(resp.data.Data.audit);
    //         if (this.ptDeleteHistory) {
    //         this.ptDeleteHistory.push(resp.data.Data.audit);
    //         }
    //     }
    //     partType.hasDeletedParts = true;
    // },
    deletePart(request) {
      const dp_id = request.row.doc_part_id;
      this.comment_doc_part = { dp_id: dp_id, deleted: true };
      let removePart = (parent, childProperty) => {
        let found = false;
        parent[childProperty]?.forEach((pt) => {
          let targetPartIndex = pt.parts.findIndex(
            (p) => p.doc_part_id === dp_id
          );
          if (targetPartIndex >= 0) {
            pt.parts.splice(targetPartIndex, 1);
            if (request.parent) {
              parent.expanded = request.parent.expanded;
              parent.totalChildren = parent.childPartTypes[0].parts.length;
            }
            pt.parts.forEach((p) => {
              utils.setDocPartStatus(
                p,
                pt,
                this.data.wordChecks,
                this.data.docStatus,
                this.data.document,
                true
              );
            });
            found = true;
          } else {
            pt.parts.forEach((p) => {
              if (removePart(p, "childPartTypes")) {
                if (request.parent) parent.expanded = request.parent.expanded;
                found = true;
              }
            });
          }
        });
        return found;
      };
      this.allSectionList.forEach((a) => removePart(a, "part_data"));
      removePart(this.document, "parttypes");

      let idx = this.partsHistory.findIndex(
        (x) => x.key === request.response.data.Data.audit.key
      );
      if (idx >= 0) {
        if (this.history && this.history.key === request.row.doc_part_id) {
          this.toggleRHS("score");
          this.history = null;
        }
        this.partsHistory.splice(idx, 1);
      }
      if (request.response.data.Data.audit) {
        this.partsHistory.unshift(request.response.data.Data.audit);
        if (this.ptDeleteHistory) {
          idx = this.ptDeleteHistory.findIndex(
            (x) => x.key === request.response.data.Data.audit.key
          );
          if (idx >= 0) {
            this.ptDeleteHistory.splice(idx, 1);
          }
          this.ptDeleteHistory.unshift(request.response.data.Data.audit);
          if (
            this.ptDeleteHistory.key === request.response.data.Data.audit.key
          ) {
            this.ptDeleteHistory = {
              ...this.ptDeleteHistory,
              ...request.response.data.Data.audit,
            };
          }
        }
        this.allHistory.push(request.response.data.Data.audit);
      }

      request.partType.hasDeletedParts = true;
      // source.parts.forEach((p) => {
      //     utils.setDocPartStatus(
      //         p,
      //         source,
      //         this.data.wordChecks,
      //         this.data.docStatus,
      //         this.data.document, true
      //     );
      // });

      let target = this.activeSection.parent_section
        ? `${this.activeSection.parent_section ?? ""}|${
            this.activeSection.tmpl_view_section_id ?? ""
          }`
        : `${this.activeSection.tmpl_view_section_id ?? ""}|`;
      this.loadSectionContent(target);
      this.setCheckSummary();
    },
    scrollToSection(issue) {
      let options = {
        container: this.docHolderCenterElementId(true), //".docHolderCenter", //this.$refs.doccontainer, //"#container",
        easing: "ease-in",
        offset: -150,
        force: true,
        cancelable: true,
        x: false,
        y: true,
      };
      let next;
      let thisSet = [];
      let processing = true;
      while (processing) {
        issue.items.forEach((t) => {
          t.instances.forEach((i) => {
            i.partsAffected.forEach((pa) => {
              if (this.dpScrolled.indexOf(pa) >= 0) {
                thisSet.push(pa);
              } else if (!next) {
                next = pa;
                thisSet.push(pa);
              }
            });
          });
        });
        if (
          this.dpScrolled.length === thisSet.length &&
          thisSet.length > 0 &&
          this.dpScrolled[thisSet.length - 1] === thisSet[thisSet.length - 1]
        ) {
          this.dpScrolled.splice(0);
          thisSet.splice(0);
        } else {
          processing = false;
        }
      }
      this.dpScrolled = thisSet;
      this.expandTarget(this.sectionParts, next);
      ScrollTo.scrollTo("#container_" + next, 500, options);
    },
    docHolderCenterElementId(withhash) {
      return `${withhash ? "#" : ""}docHolderCenter_${this.display === "sidebysidefull" ? "ss_" : ""}${this.document.doc_id}`;
    },
    scrollToSectionForComment(comment) {
      let options = {
        container: this.docHolderCenterElementId(true),
        easing: "ease-in",
        offset: -200,
        force: true,
        cancelable: true,
        x: false,
        y: true,
      };   
      this.expandTarget(this.sectionParts, comment.dp_id);
      ScrollTo.scrollTo("#container_" + comment.dp_id, 500, options);
      this.resetSectionForComment();
    },
    resetSectionForComment() {
      this.highlightedDocPartForCommentFocus = null;
      this.highlightedDocPartForCommentHover = null;
      this.comment_doc_part = null;
    },
    expandTarget(partTypes, dp_id) {
      let found = false;
      partTypes?.forEach((pt) => {
        if (pt.parts.some((p) => p.doc_part_id === dp_id)) {
          found = true;
        } else if (!found) {
          pt.parts.forEach((p) => {
            if (!found && this.expandTarget(p.childPartTypes, dp_id)) {
              found = true;
              p.expanded = true;
            }
          });
        }
      });
      return found;
    },
    highlightSection(issue) {
      this.hightLightIssue = issue;
      this.highlightedDocParts = [];
      issue.items.forEach((t) => {
        t.instances.forEach((i) => {
          this.highlightedDocParts.push(i.partsAffected.flat(1));
        });
      });

      this.highlightedDocParts = [...new Set(this.highlightedDocParts.flat(1))];
    },
    unhighlightSection() {
      this.hightLightIssue = null;
      this.highlightedDocParts = [];
    },    
    highlightSectionForCommentHover(part) {
      this.highlightedDocPartForCommentHover = part;
    },  
    highlightSectionForCommentFocus(part) {
      this.highlightedDocPartForCommentFocus = part;
    },
    isActionDisabled(getMessage) {
      if (this.adminMode)
        return getMessage ? `Unavailable in Admin Mode` : true;
      if (this.currentReviewSection.some((x) => !x.complete))
        return getMessage ? `Complete All Sections` : true;
      if (
        !this.data.document ||
        !this.checkSummary ||
        this.submitAction === null ||
        this.submitAction === undefined
      )
        return false;
      if (
        this.data.document.state.missing_data &&
        !this.submitAction.allow_errors
      ) {
        return getMessage
          ? `${this.submitAction.name} is not permitted while ${this.data.document.state.triggerDCAction.name} is missing`
          : true;
      } else if (
        this.checkSummary.errors.length &&
        !this.submitAction.allow_errors
      ) {
        return getMessage
          ? `${this.submitAction.name} is not permitted while the document has inclusivity & quality errors`
          : true;
      } else if (
        this.checkSummary.warnings.length &&
        !this.submitAction.allow_warnings
      ) {
        return getMessage
          ? `${this.submitAction.name} is not permitted while the document has inclusivity & quality warnings`
          : true;
      } else {
        return getMessage ? this.submitAction.name : false;
      }
    },
    doSubmitAction() {
      let allSections = viewUtils.getFlatSections(this.currentView.sections);
      let currentSection = allSections.find(
        (x) => x.tmpl_view_section_id === this.currentViewSectionId
      );
      if (currentSection.submit_action_id) {
        let action = this.data.document.state.actionsAvailable.find(
          (x) => x.lifecycle_action_id === currentSection.submit_action_id
        );
        this.$emit("doStateAction", action);
      }
    },
    setCheckSummary() {
      this.checkSummary = utils.documentCheckSummary(
        this.document,
        this.wordChecks,
        this.checkSummaryView,
        undefined,
        this.getSectionPartIds(),
		this.sectionUnusedParts
      );
      this.$emit("checkSummaryUpdated", this.checkSummary);
      if (this.activeSummaryCategories.length) {
        this.allCheckSummaryPanels();
      }
    },
    getSectionPartIds() {
      let ids = [];
      const getPartIds = (partTypes) => {
        partTypes && partTypes.forEach((pt) => {
          pt.parts && pt.parts.forEach((p) => {
            ids.push(p.doc_part_id);
            getPartIds(p.childPartTypes);
          });
        });
      };
      getPartIds(this.sectionParts);
      return ids;
    },
    allCheckSummaryPanels() {
      this.checkSummaryPanels = this.activeSummaryCategories.map((c) => this.checkSummary.categories.indexOf(c));
    },
    closeCheckSummaryPanels() {
      this.checkSummaryPanels = [];
    },
    closeCheckStatus() {
      this.showCheckStatus = false;
    },
    initCheckSummary() {
      this.checkSummary = utils.documentCheckSummary(
        this.document,
        this.wordChecks,
        this.checkSummaryView,
        undefined,
        this.getSectionPartIds(),
		this.sectionUnusedParts
      );
      this.$emit("checkSummaryUpdated", this.checkSummary);
    },
    /**
     * Handler for the `document.suggest-content` page action. Stashes
     * the agent's suggestions and switches the right panel to the
     * Atlas tab so the user lands on the review wizard. Called by the
     * usePageAction binding wired in setup().
     */
    beginSuggestionReview(payload) {
      // eslint-disable-next-line no-console
      console.log('[atlas] beginSuggestionReview called with', payload);
      const suggestions = Array.isArray(payload?.suggestions)
        ? payload.suggestions
        : null;
      if (!suggestions || suggestions.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('[atlas] beginSuggestionReview: no suggestions, bailing');
        return;
      }
      this.pendingSuggestions = suggestions;
      // Fresh review → fresh "already cleared the existing rows" tracking.
      // Keyed by tp_id so the host deletes a part's pre-existing rows at
      // most once per review (on the first replace-enabled apply).
      this.suggestionReplaceCleared = new Set();
      // Capture the assistant turn that emitted this page action so
      // the review panel can show "why am I looking at this?".
      // The page-action dispatch chain runs immediately after the
      // message is pushed into the messages array (finaliseComposing
      // → lastPageAction → handler), so the most recent assistant
      // message carrying `pageAction.kind === 'document.suggest-content'`
      // is the trigger. Scan from the tail to handle background-
      // narrated turns landing between the trigger and us reading.
      this.pendingSuggestionsMessage = (() => {
        const messages = this.atlasMessages;
        if (!Array.isArray(messages)) return null;
        for (let i = messages.length - 1; i >= 0; i--) {
          const m = messages[i];
          if (
            m &&
            m.role === 'assistant' &&
            m.pageAction?.kind === 'document.suggest-content'
          ) {
            return m.text || null;
          }
        }
        return null;
      })();
      // eslint-disable-next-line no-console
      console.log(
        `[atlas] pendingSuggestions set (count=${suggestions.length}); ` +
          `currentRightPanel=${this.rightPanel}`,
      );
      if (this.rightPanel !== 'atlas') {
        this.toggleRHS('atlas');
      }
    },
    /**
     * Apply one suggestion. Four routes depending on which ids the
     * agent supplied:
     *
     *   doc_part_id + no tpa_id → UPDATE the part's main text (the
     *       common "rewrite this section" case). Existing in-place
     *       reconcile.
     *
     *   doc_part_id + tpa_id (+ optional dpa_id) → UPDATE a SPECIFIC
     *       attribute's value on an existing part. Part's main text
     *       is preserved. `dpa_id` present → update the attribute
     *       row; absent → INSERT a new attribute row (saveDocumentPart
     *       handles both inside its `attributes` array based on
     *       whether the entry carries a positive dpa_id).
     *
     *   no doc_part_id + no tpa_id → CREATE a new doc_part for the
     *       given `tp_id` with `final_text` as the body.
     *
     *   no doc_part_id + tpa_id → CREATE both: a new doc_part for
     *       `tp_id` AND its first attribute (`tpa_id` → `final_text`).
     *       Surfaces in `attributes[]` so saveDocumentPart inserts
     *       both rows in one transaction.
     *
     * In every path we throw on save failure so the wizard can
     * surface the error on the row and keep the user on it for retry.
     */
    async applySuggestion({
      tp_id,
      doc_part_id,
      tpa_id,
      dpa_id,
      final_text,
      replace_existing_rows,
    }) {
      // "Replace existing rows" opt-in (from the review panel) for a
      // reduce/combine. The suggestions are the COMPLETE new set for a
      // multi-row part, so clear the part's OTHER existing rows — those
      // not targeted by any suggestion in this review — before applying
      // this one. Runs for BOTH update and create cards (the agent may
      // express the consolidation either way) and at most once per part
      // per review: the first replace-enabled apply removes the leftover
      // rows (reversible soft-delete), later applies in the group just
      // update/create. Doing it up front, before any new row is made,
      // also keeps the delete snapshot free of rows we just created.
      if (replace_existing_rows && tp_id != null) {
        const pt = this.findPartType(tp_id, this.data.document.parttypes);
        if (pt && (pt.multi_row || pt.tmpl_part_metadata?.multi_row)) {
          if (!this.suggestionReplaceCleared) {
            this.suggestionReplaceCleared = new Set();
          }
          if (!this.suggestionReplaceCleared.has(tp_id)) {
            await this.deleteExistingRowsForReplace(tp_id);
            this.suggestionReplaceCleared.add(tp_id);
          }
        }
      }
      if (doc_part_id) {
        const docpart = this.findDocPartById(doc_part_id);
        if (!docpart) {
          throw new Error(`Document part ${doc_part_id} not found in this view`);
        }
        const docPartType = this.findPartType(
          docpart.tmpl_part_id,
          this.data.document.parttypes,
        );
        const isAttr =
          docPartType?.tmpl_part_metadata?.attributes?.length >= 2;

        if (tpa_id) {
          // ── ATTRIBUTE-TARGETED UPDATE / INSERT ──────────
          // Clone the live attribute list, swap the targeted entry's
          // text, or append a new entry if the agent surfaced a slot
          // the live part hadn't materialised yet.
          const liveAttrs = Array.isArray(docpart.attributes)
            ? docpart.attributes
            : [];
          let foundExisting = false;
          const nextAttrs = liveAttrs.map((a) => {
            if (a.tpa_id === tpa_id) {
              foundExisting = true;
              return { ...a, text: final_text };
            }
            return a;
          });
          if (!foundExisting) {
            nextAttrs.push({
              tpa_id,
              dpa_id: dpa_id ?? 0,
              text: final_text,
            });
          }
          const payload = {
            // Pass the current text verbatim — saveDocumentPart's
            // UPDATE path rewrites varVal on every call, so omitting
            // would blank the body. Attribute-targeted edits must not
            // touch the part's primary text.
            text: docpart.text ?? '',
            doc_part_id: docpart.doc_part_id,
            doc_part_type: docPartType?.type,
            doc_id: this.data.document.doc_id,
            system_number: this.data.document.system_number,
            tmpl_part_id: docpart.tmpl_part_id,
            notes: docpart.notes ?? null,
            parent_dp_id: null,
            is_essential: docpart.is_essential,
            quality: docpart.quality,
            sequence: docpart.sequence,
            attributes: nextAttrs,
          };
          const result = await viewUtils.updateDocPart(payload);
          // Reconcile locally so the live render reflects the edit
          // without a parent re-fetch. Three things need to land:
          //
          //   1. attributes array — already a fresh array (from
          //      `nextAttrs`) and the targeted entry is a fresh
          //      spread object. Reference change is REQUIRED here:
          //      TextInput's `value` watcher fires only on prop
          //      identity change, so mutating `.text` in place would
          //      leave the input showing the pre-edit text.
          //   2. docpart.text — assembled view text. Consumers
          //      (renderers, future save payloads, audit diffs)
          //      read this; without recompute it stays at the
          //      pre-edit body even though the underlying attribute
          //      now carries the new value.
          //   3. docpart.subParts — `partToSubParts(text)` returns
          //      the {text, type} array the renderer iterates;
          //      passing `attributesToText` directly would shove a
          //      raw string into subParts and break the bullet /
          //      paragraph splitting.
          docpart.attributes = nextAttrs;
          if (isAttr) {
            docpart.text = utils.attributesToText(
              docPartType.tmpl_part_metadata.attributes,
              docpart.attributes,
            );
            docpart.subParts = utils.partToSubParts(docpart.text);
          }
          await this.updatePart({ part: docpart, response: result });
          return;
        }

        // ── PART-TEXT UPDATE (existing behaviour) ───────────
        const payload = {
          text: final_text,
          doc_part_id: docpart.doc_part_id,
          doc_part_type: docPartType?.type,
          doc_id: this.data.document.doc_id,
          system_number: this.data.document.system_number,
          tmpl_part_id: docpart.tmpl_part_id,
          notes: docpart.notes ?? null,
          parent_dp_id: null,
          is_essential: docpart.is_essential,
          quality: docpart.quality,
          sequence: docpart.sequence,
          attributes: isAttr ? docpart.attributes : [],
        };
        const result = await viewUtils.updateDocPart(payload);
        docpart.text = final_text;
        if (docpart.attributes?.length === 1) {
          // Replace the attribute object with a NEW reference so
          // TextInput's `:value` watcher fires and re-inits the
          // displayed text. In-place mutation (`.text = …`) is the
          // pattern used by user-initiated edits in View_Parts, but
          // it relies on the input already showing the typed text;
          // for an agent-initiated edit there's no prior keystroke,
          // so the prop diff is our only signal.
          //
          // Gate on `length === 1`, NOT `isAttr` (which is
          // `attributes.length >= 2`): the renderer binds each
          // TextInput to an entry in `part.attributes`, so a plain-
          // text part's lone text-carrying attribute (a real single
          // attribute, or the dummy synthesised for an attribute-less
          // part) must be refreshed here too — otherwise filling an
          // empty row leaves the visible input blank until reload.
          // (`isAttr && length === 1` was unreachable — the two
          // conditions are mutually exclusive — so this never ran.)
          docpart.attributes = [
            { ...docpart.attributes[0], text: final_text },
          ];
        }
        // Always derive subParts via partToSubParts(text) — the
        // renderer expects an array of {text, type} entries, not the
        // raw assembled string that attributesToText returns.
        docpart.subParts = utils.partToSubParts(final_text);
        await this.updatePart({ part: docpart, response: result });
        return;
      }

      // ── CREATE PATH ─────────────────────────────────────
      if (!tp_id) {
        throw new Error(
          'Suggestion missing both doc_part_id and tp_id — cannot apply',
        );
      }
      let docPartType = this.findPartType(
        tp_id,
        this.data.document.parttypes,
      );
      if (!docPartType) {
        throw new Error(
          `Template part ${tp_id} not found in this document's template`,
        );
      }
      // Replace-existing clearing already ran at the top of this method
      // (it applies to update and create cards alike). If it deleted rows
      // for this part, re-resolve so the sequence / empty-row logic below
      // sees the post-delete tree.
      if (replace_existing_rows && this.suggestionReplaceCleared?.has(tp_id)) {
        docPartType =
          this.findPartType(tp_id, this.data.document.parttypes) ||
          docPartType;
      }
      // Prefer filling an existing EMPTY row before creating a new one.
      // Multi-row parts are commonly seeded with a blank starter row (or
      // the user left earlier rows blank); accepting N suggestions would
      // otherwise strand those blanks above the freshly-created rows.
      // We redirect into the UPDATE path for the empty row instead.
      //
      // Sequential applies (the wizard awaits each one) keep this
      // correct: filling a row mutates the live tree synchronously, so
      // the next suggestion's scan skips the row we just populated and
      // moves on to the next blank / a new row.
      if (docPartType.multi_row || docPartType.tmpl_part_metadata?.multi_row) {
        const emptyRow = this.findEmptyRow(docPartType, tpa_id);
        if (emptyRow) {
          await this.applySuggestion({
            tp_id,
            doc_part_id: emptyRow.doc_part_id,
            tpa_id,
            dpa_id,
            final_text,
          });
          return;
        }
      }
      // saveDocumentPart treats `doc_part_id <= 0` as an insert —
      // see [shared/services] saveDocumentPart's `isUpdate` check.
      // When the agent also supplies `tpa_id`, attach the initial
      // attribute so the part + its first attribute row land in one
      // save (saveDocumentPart's attribute handler inserts new
      // doc_part_attr rows when their dpa_id is missing/0).
      const payload = {
        text: tpa_id ? '' : final_text,
        doc_part_id: 0,
        doc_part_type: docPartType.type,
        doc_id: this.data.document.doc_id,
        system_number: this.data.document.system_number,
        tmpl_part_id: tp_id,
        notes: null,
        parent_dp_id: null,
        is_essential: 0,
        quality: null,
        // Sequence at the end of the part-type's current siblings;
        // 1 if there are none yet. Doesn't affect correctness — the
        // backend recomputes sequence on render — but keeps it stable
        // until the parent re-fetch lands.
        sequence: (docPartType.parts?.length ?? 0) + 1,
        attributes: tpa_id
          ? [{ tpa_id, dpa_id: 0, text: final_text }]
          : [],
      };
      const result = await viewUtils.updateDocPart(payload);
      // Build the LOCAL render attributes from the template's attribute
      // schema — NOT from the bare `payload.attributes` we sent to save.
      // The renderer iterates `part.attributes` to draw one TextInput
      // per attribute, and `initialiseDocPart` only synthesises a
      // placeholder attribute for an attribute-less part when the part
      // type carries `requireInit` (set when an admin adds a whole part
      // TYPE — never on a live part type gaining a row). So the old
      // `attributes: payload.attributes` left the new row empty:
      //   - plain-text multi-row part (no tpa_id) → `[]` → no TextInput
      //     renders at all → the row shows blank until a reload
      //     re-hydrates it from the DB;
      //   - attributed part → a single bare `{tpa_id,text}` entry that
      //     drops the part's other attribute slots.
      // Mirror `viewUtils.instantiateNewRow`: map every template
      // attribute (text on the targeted tpa_id, default_text elsewhere),
      // or fall back to a dummy attribute carrying the body for
      // attribute-less parts. `updatePart`'s addPart branch then patches
      // each entry's `dpa_id`/text from `newRowAttributes` by tpa_id.
      const metaAttrs = docPartType.tmpl_part_metadata?.attributes ?? [];
      const renderAttributes = metaAttrs.length
        ? metaAttrs.map((a) => ({
            ...a,
            dpa_id: 0,
            text: a.tpa_id === tpa_id ? final_text : a.default_text ?? '',
            editing: false,
            isDirty: true,
            active: true,
            tags: [],
          }))
        : [
            viewUtils.dummyAttribute(
              { doc_part_id: 0, text: final_text },
              docPartType,
            ),
          ];
      // Splice the newly-created part into the live document tree in
      // place. `updatePart`'s addPart branch detects this as an insert
      // via `response.result.Data.newRow` and patches `doc_part_id`
      // (and any `dpa_id`s on attributes) onto our placeholder part
      // before pushing it into the matching parttype's `parts[]`.
      //
      // Tree-mutation route (rather than emitting `reloadDocument` for
      // a parent re-fetch) keeps us aligned with the UPDATE branches
      // above and avoids the null-payload crash in
      // cDocumentFullNEW.documentRefreshed (which dereferences
      // `responseData.documents` and doesn't tolerate null).
      const newPart = {
        doc_part_id: Number(result.result.Data.newRow.doc_part_id),
        tmpl_part_id: tp_id,
        parent_dp_id: null,
        text: payload.text,
        attributes: renderAttributes,
        is_essential: payload.is_essential,
        quality: payload.quality,
        notes: payload.notes,
        sequence: payload.sequence,
        // The render path and initialiseDocPart assume every part
        // carries these arrays — `View_Parts.initialiseDocPart` does
        // `p.subParts.length` unguarded (throws on undefined), the
        // template guards `part.childPartTypes` truthy but still does
        // `part.linked_content.length` on the viewLinked branch, and
        // permissions_list is passed down as a prop. The original
        // (server-loaded) parts ship with these fields populated, so
        // we have to mirror that shape when synthesising one locally.
        subParts: utils.partToSubParts(payload.text),
        childPartTypes: [],
        linked_content: [],
        permissions_list: {
          canEdit: true,
          viewPermissionOverride: null,
          displayPermissionOverride: null,
          editPermissionOverride: null,
          permissions: [],
          hierarchyPermissions: [],
          view_dependencies: [],
        },
        hasComments: false,
        locked: false,
        expanded: false,
        hover: false,
      };
      await this.updatePart({ part: newPart, response: result });
      // Force ViewParts to re-init by changing the `sectionParts`
      // reference. The rendered ViewParts watches its `partTypes`
      // prop (bound to `sectionParts.filter(...)`) and only re-runs
      // `init()` — which calls `initialiseDocPart` to wire lookup /
      // hierarchy / wordChecks metadata onto every part's attributes
      // — when that reference changes. Pushing into
      // `sectionParts[i].parts` mutates the array in place; the
      // filter's tracked deps don't move, so the watcher never fires
      // and the newly-created part either doesn't show at all or
      // renders without its TextInput cells. A shallow clone is
      // enough — entries are still the same objects, so existing
      // parts keep their references and their child inputs don't
      // lose internal state.
      if (Array.isArray(this.sectionParts)) {
        this.sectionParts = [...this.sectionParts];
      }
    },
    /**
     * Recursive lookup for a docpart by doc_part_id. The document
     * tree is `parttypes[].parts[].childPartTypes[].parts[]…` —
     * arbitrary depth depending on the template. Returns the first
     * match or null.
     */
    findDocPartById(targetId) {
      const search = (parttypes) => {
        if (!parttypes) return null;
        for (const pt of parttypes) {
          if (!pt.parts) continue;
          for (const p of pt.parts) {
            if (p.doc_part_id === targetId) return p;
            const nested = search(p.childPartTypes);
            if (nested) return nested;
          }
        }
        return null;
      };
      // `sectionParts` is the tree the rendered ViewParts iterates
      // (`:partTypes="sectionParts.filter(...)"`). It's a deep-clone
      // of the source data — produced by `loadSectionContent` via
      // `JSON.parse(JSON.stringify(...))` — and is the ONLY copy whose
      // mutations the live render actually sees. Searching the
      // source `this.data.document.parttypes` instead lands edits on
      // a parallel tree whose state never reaches the DOM, which is
      // why agent-applied suggestions saved to the database but
      // didn't appear on screen until reload.
      //
      // Fall back to the source tree only if the part isn't in the
      // currently-loaded section (e.g. agent suggested an edit to a
      // part in a section the user hasn't opened yet). The source-
      // tree match still satisfies the integrity checks in
      // applySuggestion; updatePart will splice it in and the next
      // loadSectionContent re-clones from the updated source.
      return (
        search(this.sectionParts) ?? search(this.data?.document?.parttypes)
      );
    },
    /**
     * Find an existing EMPTY row of a multi-row part type that a new
     * suggestion can fill instead of creating another row. "Empty" is
     * judged against the slot the suggestion targets: the attribute
     * matching `tpa_id` when one is given (the row hasn't authored that
     * attribute yet), or the row's main text otherwise. Locked /
     * non-editable rows are never offered. Returns the first match in
     * the part type's current order, or null when every row has content.
     */
    findEmptyRow(docPartType, tpa_id) {
      const rows = Array.isArray(docPartType?.parts) ? docPartType.parts : [];
      return (
        rows.find(
          (p) =>
            // Must be a persisted row so the redirect actually hits the
            // UPDATE path. Skipping `doc_part_id <= 0` also prevents an
            // infinite loop: a client-only placeholder (id 0) is falsy,
            // so delegating it would fall back into this CREATE path and
            // re-find the same row forever.
            p.doc_part_id > 0 &&
            !p.locked &&
            p.permissions_list?.canEdit !== false &&
            this.isRowContentEmpty(p, tpa_id),
        ) ?? null
      );
    },
    /**
     * Whether the slot a suggestion targets on `part` currently holds
     * no content. For an attribute-targeted suggestion (`tpa_id` set)
     * the row is empty when it has no authored value for that attribute;
     * for a whole-part suggestion it's empty when the part text is blank.
     */
    isRowContentEmpty(part, tpa_id) {
      const blank = (t) => !t || String(t).trim().length === 0;
      if (tpa_id != null) {
        const attr = (part.attributes || []).find((a) => a.tpa_id === tpa_id);
        return !attr || blank(attr.text);
      }
      return blank(part.text);
    },
    /**
     * Soft-delete a multi-row part's pre-existing rows as part of a
     * "replace existing" apply. Snapshots the part's active rows that are
     * NOT targeted by an update suggestion in the current review (those
     * are being edited, not replaced), then removes each via the same
     * tested path the UI's row delete uses — `viewUtils.deletePart`
     * (POST document/removedocpart, a reversible soft delete) followed by
     * the `deletePart` reconciler, which strips the row from every tree,
     * records the audit/deleted-rows history, and re-clones the rendered
     * section. Callers MUST invoke this BEFORE creating any replacement
     * row so the snapshot can never include a row we just made.
     */
    async deleteExistingRowsForReplace(tp_id) {
      const pt = this.findPartType(tp_id, this.data.document.parttypes);
      if (!pt) return;
      const preserve = new Set(
        (this.pendingSuggestions || [])
          .filter((x) => x.tp_id === tp_id && x.doc_part_id)
          .map((x) => Number(x.doc_part_id)),
      );
      const rows = (pt.parts || []).filter(
        (p) => p.doc_part_id > 0 && !preserve.has(p.doc_part_id),
      );
      for (const row of rows) {
        const resp = await viewUtils.deletePart({
          doc_part_id: row.doc_part_id,
          doc_part_type: pt.type,
          tmpl_part_id: row.tmpl_part_id,
        });
        this.deletePart({ row, partType: pt, parent: null, response: resp });
      }
    },
    /**
     * Find a part type definition by tmpl_part_id. Mirrors the inline
     * `findPartType` helper inside the existing revert flow — pulled
     * out as a method here so both the revert and apply-suggestion
     * paths share one implementation.
     */
    findPartType(tmpl_part_id, parttypes) {
      if (!parttypes) return null;
      for (const pt of parttypes) {
        if (pt.tmpl_part_id === tmpl_part_id) return pt;
        for (const p of pt.parts || []) {
          const childPt = this.findPartType(tmpl_part_id, p.childPartTypes);
          if (childPt) return childPt;
        }
      }
      return null;
    },
    /**
     * Push the current document into Atlas's page context. The agent
     * reads this on every sendMessage so the conversation is scoped to
     * "the document the user is editing right now". Clears with null
     * when no document is loaded — the singleton ref then falls back
     * to whatever the next host page declares.
     *
     * `document.system_number` is rm-portal's user-facing `RM-xxxxx`
     * identifier; `data.reference` maps it back to the cross-portal
     * name the agent expects (matches what cDocumentFullNEW sends).
     */
    applyAtlasDocumentContext() {
      const doc = this.data?.document ?? this.document ?? null;
      const ref = doc?.system_number ?? null;
      const docId = doc?.doc_id ?? null;
      this.setAtlasDocumentContext(ref, docId);
    },
    toggleRHS(val) {
      if (val === 'all-comments' && !this.canViewComments) {
        val = 'suggestions';
      }
      if (val === 'suggestions' && !this.showSuggestions) {
        val = 'score';
      }
      if (val === 'score' && !this.showScoring) {
        val = 'database';
      }

      // Assign rightPanel BEFORE syncing global open state. The
      // atlasOpen watcher reads `this.rightPanel` to short-circuit
      // when it's already in sync — flipping `setAtlasOpen` first
      // would re-enter toggleRHS('atlas') in a loop.
      const previousPanel = this.rightPanel;
      this.rightPanel = val;

      // Sync the global flyout `open` state with the Atlas tab so the
      // header AtlasFlyoutButton, the tab itself, and the slide-in
      // (when the doc closes) all reflect the same truth.
      if (val === 'atlas' && !this.atlasOpen) {
        this.setAtlasOpen(true);
      } else if (previousPanel === 'atlas' && val !== 'atlas' && this.atlasOpen) {
        this.setAtlasOpen(false);
      }
      switch (val) {
        case "permissions":
          this.rightPanelHeader = "Permissions";
          break;
        case "partPermissions":
          this.rightPanelHeader = "Permissions";
          break;
        case "hidden":
          this.rightPanelHeader = "";
          break;
        case "suggestions":
          this.docTitle = {
            doc_name: this.data.document.doc_name,
            doc_id: this.data.document.doc_id,
          };
          this.rightPanelHeader = "Suggestions";
          this.rightPanelTab = "suggestions";
          break;
        case "database":
          this.rightPanelHeader = "" // "Database";
          this.rightPanelTab = "database";
          break;
        case "DCE":
          this.rightPanelHeader = "Dynamic Content Engine";
          break;
        case "allHistory":
          this.rightPanelHeader = "All History";
          this.showAllHistory();
          break;
        case "score":
          this.rightPanelHeader = ""; // this.showRHSExpansionHeaders ? "Feedback" : "Document Score";
          this.initCheckSummary();
          this.rightPanelTab = "score";
          break;
        case "collaboration":
          this.rightPanelHeader = "Collaboration";
          break;
        case "skills":
          this.rightPanelHeader = "Skills";
          break;
        case "comments":
          this.rightPanelHeader = "";
          break;
        case "all-comments":
          this.rightPanelHeader = "";
          this.rightPanelTab = "all-comments";
          break;
        case "atlas":
          this.rightPanelHeader = "";
          this.rightPanelTab = "atlas";
          // Refresh Atlas's page context whenever the user activates
          // the tab — covers cases where the document loaded before
          // any parent (e.g. cDocumentFullNEW) wired its own context.
          this.applyAtlasDocumentContext();
          break;
        case "contentGen":
          this.rightPanelHeader = "";
          this.rightPanelTab = "contentGen";

          // Resume active execution if exists (similar to dialog logic)
          this.$nextTick(() => {
            if (this.$refs.generateContentPanelRef) {
              if (this.generateContentData.activeExecution?.executionId) {
                if (this.$refs.generateContentPanelRef.resumeActiveGeneration) {
                  console.log('Resuming active execution in panel:', this.generateContentData.activeExecution.executionId);
                  this.$refs.generateContentPanelRef.resumeActiveGeneration(
                    this.generateContentData.activeExecution.executionId
                  );
                }
              } else if (this.$refs.generateContentPanelRef.activate) {
                // Otherwise, just activate normally
                this.$refs.generateContentPanelRef.activate();
              }
            }
          });
          break;
      }
      if (!['score', 'comments','all-comments'].includes(val)) {
        this.$emit("hideComments");
      }
    },
    toggleLHS(content) {
      this.leftPanel = content;

      if (content === "sections") {
        let target = this.activeSection.parent_section
          ? `${this.activeSection.parent_section ?? ""}|${
              this.activeSection.tmpl_view_section_id ?? ""
            }`
          : `${this.activeSection.tmpl_view_section_id ?? ""}|`;
        this.loadSectionContent(target);
      }
    },
    userInitials() {
      return this.$loginState.user.name
        .split(" ")
        .map((x) => x.substr(0, 1))
        .join("");
    },
    showDeletedPartHistory(pt) {
      this.history = null;
      this.headerHistoryShow = false;
      this.ptDeleteHistoryPT = pt;
      this.ptDeleteHistory = this.partsHistory
        ? this.partsHistory.filter((pa) => pa.isDeleted && pa.name === pt.type)
        : null;
      this.rightPanel = "history";
      this.rightPanelHeader = `${pt.type} Delete History`;
    },
    showPartHistory(request) {
      if (this.showAllComments && this.canViewComments && request.collab){ // && request.part.hasComments) {
        this.comment_doc_part = { 
          dp_id: request.part.doc_part_id,
          part_type: request.previous.ptText,
          part_type_sequence: request.previous.sorting.reduce((p,c) => p + c.sort_key, 0),
          dpa_tag_id: request.tag ? request.tag.dpa_tag_id : null,
          tag_value: request.tag ? request.tag.value : null,
        };
        this.toggleRHS("all-comments");
        this.highlightSectionForCommentFocus(this.comment_doc_part);
        this.$emit('showComments',true);
        return;
      }
      this.collabHistory = !!request.collab;
      this.comment.dp_id = request.part.doc_part_id;
      this.comment.part = request.collab ? request.part : null;
      this.comment.partType = request.collab ? request.partType : null;
      this.comment.tag = request.tag ? request.tag : null;
      this.history = this.partsHistory
        ? this.partsHistory.find((pa) => pa.key === request.part.doc_part_id)
        : null;
      if (this.history) {
        this.history.part = request.part;
        this.history.partType = request.partType;
      }
      this.rightPanel = "history";
      this.rightPanelHeader = `${this.history.name} ${
        this.collabHistory ? "Activity" : "History"
      }`;
    },
    showAllHistory() {
      let allSections = viewUtils.getFlatSections(this.currentView.sections);
      let currentSection = allSections.find(
        (x) => x.tmpl_view_section_id === this.currentViewSectionId
      );
      this.allHistoryData = currentSection.section_history;
    },
    triggerNotification(text, type) {
      if (this.display === "sidebysidefull") {
        this.$emit("triggerNotification", text, type);
        return;
      }
      this.notification = {
        text: text,
        type: type,
      };
    },
    resyncItem(item) {
      let flatParts = viewUtils.genericFlatten(
        this.document.parttypes,
        "childPartTypes"
      );
      let source = flatParts.find((x) => x.tmpl_part_id === item.tmpl_part_id);
      let isChild = source.tmpl_part_metadata.parent_tp_id;
      if (source) {
        if (!isChild) {
          item.parts.forEach((part) => {
            let idx = source.parts.findIndex(
              (x) => x.doc_part_id === part.doc_part_id
            );
            if (idx > -1) {
              source.parts[idx] = part;
            }
          });
          source.parts = source.parts.sort(
            (a, b) => (a.sequence > b.sequence && 1) || -1
          );
        } else {
          let parentSource = flatParts.find(
            (x) => x.tmpl_part_id === source.tmpl_part_metadata.parent_tp_id
          );
          item.parts.forEach((part) => {
            let idx = parentSource.parts.findIndex(
              (x) => x.doc_part_id === part.parent_dp_id
            );
            if (idx > -1) {
              let cpt = parentSource.parts[idx].childPartTypes.find(
                (x) => x.tmpl_part_id === part.tmpl_part_id
              );
              let childIdx = cpt.parts.findIndex(
                (x) => x.doc_part_id === part.doc_part_id
              );
              if (childIdx > -1) {
                cpt.parts[childIdx] = part;
              }
              cpt.parts = cpt.parts.sort(
                (a, b) => (a.sequence > b.sequence && 1) || -1
              );
            }
          });
        }
      }

      if (isChild) {
        let all = this.allSectionList.filter((x) =>
          x.part_data.some(
            (p) => p.tmpl_part_id === source.tmpl_part_metadata.parent_tp_id
          )
        );
        all.forEach(async (a) => {
          let parentSectionSource = a.part_data.find(
            (x) => x.tmpl_part_id === source.tmpl_part_metadata.parent_tp_id
          );
          item.parts.forEach((part) => {
            let parent = parentSectionSource.parts.find(
              (x) => x.doc_part_id === part.parent_dp_id
            );
            let cpt = parent.childPartTypes.find(
              (x) => x.tmpl_part_id === part.tmpl_part_id
            );
            let childIdx = cpt.parts.findIndex(
              (x) => x.doc_part_id === part.doc_part_id
            );
            if (childIdx > -1) {
              cpt.parts[childIdx] = part;
            }
            cpt.parts = cpt.parts.sort(
              (a, b) => (a.sequence > b.sequence && 1) || -1
            );
          });
        });
      } else {
        let all = this.allSectionList.filter((x) =>
          x.part_data.some((p) => p.tmpl_part_id === source.tmpl_part_id)
        );
        all.forEach(async (a) => {
          let sectionSource = a.part_data.find(
            (x) => x.tmpl_part_id === item.tmpl_part_id
          );
          item.parts.forEach((part) => {
            let idx = sectionSource.parts.findIndex(
              (x) => x.doc_part_id === part.doc_part_id
            );
            if (idx > -1) {
              sectionSource.parts[idx] = part;
            }
          });
          sectionSource.parts = sectionSource.parts.sort(
            (a, b) => (a.sequence > b.sequence && 1) || -1
          );
        });
      }
    },
    async reorderParts(item) {
      let data = item.parts.map((r, i) => {
        let ret = {};
        ret.sequence = i + 1;
        ret.type = item.type;
        ret.doc_part_id = r.doc_part_id;
        return ret;
      });
      item.parts = item.parts.map((sp) => {
        let newOrder = data.find((x) => x.doc_part_id === sp.doc_part_id);
        return {
          ...sp,
          sequence: newOrder.sequence,
        };
      });
      item.parts = item.parts.sort(
        (a, b) => (a.sequence > b.sequence && 1) || -1
      );
      await viewUtils.saveItemOrder(data);
      this.resyncItem(item);
      this.triggerNotification("Part Order Updated", "success");
    },
    reorderPartList(item, order) {
      item.parts = item.parts.map((sp) => {
        let newOrder = order.find((x) => x.doc_part_id === sp.doc_part_id);
        return {
          ...sp,
          sequence: newOrder
            ? newOrder.sequence
            : order[order.length - 1].sequence + 1,
        };
      });
      item.parts = item.parts.sort(
        (a, b) => (a.sequence > b.sequence && 1) || -1
      );
      return item;
    },
    async changeOrder(item, save) {
      let data = item.parts.map((r, i) => {
        let ret = {};
        ret.sequence = i + 1;
        ret.type = item.type;
        ret.doc_part_id = r.doc_part_id;
        return ret;
      });

      if (save) {
        await viewUtils.saveItemOrder(data);
        this.triggerNotification("Part Order Updated", "success");
      }

      return this.reorderPartList(item, data);
    },
    async processResults(list) {
      this.dragEnd();
      for (const r of list) {
        await this.updatePart({ part: r.part, response: r.resp });
      }
      let target = this.activeSection.parent_section
        ? `${this.activeSection.parent_section ?? ""}|${
            this.activeSection.tmpl_view_section_id ?? ""
          }`
        : `${this.activeSection.tmpl_view_section_id ?? ""}|`;
      this.loadSectionContent(target);
      this.triggerNotification("Content Updated", "success");
    },
    async updateContentPart(request) {
      let updatedItem = request.response.data.data;
      if (request.part.parent_id === null) {
        let all = this.allSectionList.filter((x) =>
          x.part_data.some(
            (p) =>
              p.tmpl_view_section_part_id ===
              updatedItem.tmpl_view_section_part_id
          )
        );
        all.forEach((a) => {
          let sectionSource = a.part_data.find(
            (x) =>
              x.tmpl_view_section_part_id ===
              updatedItem.tmpl_view_section_part_id
          );
          if (sectionSource.tmpl_part_metadata.content_type === "TABLE") {
            updatedItem = {
              ...updatedItem,
              rows: request.part.rows,
            };
          }

          sectionSource.parts[0].attributes[0] = updatedItem;
        });
      } else {
        let all = this.allSectionList.filter((x) =>
          x.part_data.some(
            (p) => p.tmpl_view_section_part_id === request.part.parent_id
          )
        );
        all.forEach((a) => {
          let sectionSource = a.part_data.find(
            (x) => x.tmpl_view_section_part_id === request.part.parent_id
          );
          let sectionDocPart = sectionSource.parts.find(
            (x) => x.doc_part_id === updatedItem.doc_part_id
          );
          let linkedContent = sectionDocPart.linked_content.find(
            (x) =>
              x.tmpl_view_section_part_id ===
              updatedItem.tmpl_view_section_part_id
          );
          linkedContent.parts[0].attributes[0] = {
            ...request.part,
            value: updatedItem.value,
          };
        });
      }
    },
    togglePartDisplay(part, item) {
      item.tmpl_part_metadata.linked_parts.forEach((lp) => {
        let sourcePart = part;
        if (lp.tpa_id) {
          sourcePart = sourcePart.attributes.find(
            (cpa) => cpa.tpa_id === lp.tpa_id
          );
        }

        if (lp.tmpl_view_section_part_id) {
          let all = this.allSectionList.filter((x) =>
            x.part_data.some(
              (p) =>
                p.tmpl_view_section_part_id === lp.tmpl_view_section_part_id
            )
          );
          all.forEach(async (a) => {
            let targetPart = a.part_data.find(
              (x) =>
                x.tmpl_view_section_part_id === lp.tmpl_view_section_part_id
            );
            if (targetPart) {
              let permissionViewAllowed =
                targetPart.permissions_list.viewPermissionOverride === null ||
                targetPart.permissions_list.viewPermissionOverride === true;
              if (permissionViewAllowed) {

                if(targetPart.permissions_list.view_dependencies.length === 1) {
                  
                  let textVals = lp.display_values.split("|");
                  let viewPermission =
                    lp.display_type === "SHOW" &&
                    textVals.includes(sourcePart.text)
                      ? true
                      : false;
                      
                  viewPermission = lp.display_condition === "NOT_EQUAL" ? !viewPermission : viewPermission;
                  targetPart.permissions_list.displayPermissionOverride =
                    viewPermission;
                } else if (targetPart.permissions_list.view_dependencies.length > 1) {
                  let groupType = targetPart.permissions_list.view_dependencies[0].permission_operator;
                  let criteria = [];
                  targetPart.permissions_list.view_dependencies.forEach(c => {
                    let tp = a.part_data.find(cp => cp.tmpl_part_id === c.tmpl_part_id)?.parts[0];
                    if(c.tpa_id && tp){
                    tp = tp.attributes.find(cpa => cpa.tpa_id === c.tpa_id);
                    }

                    let textVals = c.display_values.split("|");
                    let result = c.display_type === "SHOW" && textVals.includes(tp?.text) ? true : false;
                    result = c.display_condition === "NOT_EQUAL" ? !result : result;
                    criteria.push({
                      tmpl_view_section_display_id: c.tmpl_view_section_display_id,
                      result: result
                    })
                  })
                  let displayPermission = false;
                  switch(groupType){
                    case "AND":
                      displayPermission = criteria.every(x => x.result);
                      break;
                    case "OR":
                      displayPermission = criteria.some(x => x.result);
                      break;
                  }
                  targetPart.permissions_list.displayPermissionOverride = displayPermission;
                }
              }
            }
          });
        } else {
          let target = this.allSectionList.find(
            (x) => x.tmpl_view_section_id === lp.tmpl_view_section_id
          );
          let viewPermission =
            lp.display_type === "SHOW" && sourcePart.text === lp.display_values
              ? true
              : false;

          /*if(!viewPermission){
                        let dependentSections = target.part_data.filter(x => x.tmpl_part_metadata.linked_parts.length > 0 && x.tmpl_part_metadata.linked_parts.some(p => p.tmpl_view_section_part_id === null)).map(x => {
                            return x.tmpl_part_metadata.linked_parts.filter(p => p.tmpl_view_section_part_id === null).map(s => {
                                return s.tmpl_view_section_id
                            }).flat(1)
                        }).flat(1)

                        let dependentSections = target.part_data.filter(x => x.tmpl_part_metadata.linked_parts.length > 0 && x.tmpl_part_metadata.linked_parts.some(p => p.tmpl_view_section_part_id === null)).flat(1);

                        if(dependentSections){
                            dependentSections.forEach(s => {
                                this.togglePartDisplay(null, s);
                                //let sub = this.allSectionList.find(x => x.tmpl_view_section_id === s); 
                                //console.log(sub);
                                //sub.permissions_list.displayPermissionOverride = viewPermission;  
                            })
                        }
                    }*/

          target.permissions_list.displayPermissionOverride = viewPermission;

          let newNavPath = this.allSectionList
            .filter(
              (x) =>
                x.permissions_list.displayPermissionOverride === null ||
                x.permissions_list.displayPermissionOverride === true
            )
            .map((x) => {
              if (x.parent_section) {
                return `${x.parent_section ?? ""}|${
                  x.tmpl_view_section_id ?? ""
                }`;
              } else {
                return `${x.tmpl_view_section_id ?? ""}|`;
              }
            });

          this.currentView.navigationPath = newNavPath;
        }
      });
    },
    async updatePart(request) {
      let addPart = (parent, childProperty, parent_dp_id, tp_id, saveOrder) => {
        let found = false;
        parent[childProperty]?.forEach(async (pt) => {
          let targetParent = pt.parts.find(
            (p) => p.doc_part_id === parent_dp_id
          );
          let isTargetPartType =
            pt.tmpl_part_id === tp_id &&
            (parent.doc_part_id === parent_dp_id ||
              (parent.doc_part_id === undefined && parent_dp_id === null));
          if (targetParent) {
            found = addPart(
              targetParent,
              "childPartTypes",
              parent_dp_id,
              tp_id,
              saveOrder
            );
            if (found) {
              targetParent.totalChildren =
                targetParent.childPartTypes[0].parts.length;
            }
          } else if (isTargetPartType) {
            if (
              !pt.parts.some((p) => p.doc_part_id === request.part.doc_part_id)
            ) {
              let index = request.part.insertOrder
                ? pt.parts.findIndex(
                    (x) => x.sequence >= request.part.insertOrder
                  )
                : -1;
              if (index > 0) {
                pt.parts.splice(index, 0, request.part);
                pt.parts.forEach((p, i) => (p.sequence = i + 1));
                if (saveOrder) {
                  await viewUtils.saveItemOrder(pt.parts);
                }
              } else {
                pt.parts.push(request.part);
              }
            }
            // if (parent.doc_part_id) parent.expanded = true;
            found = true;
            pt.parts.forEach((p) => {
              utils.setDocPartStatus(
                p,
                pt,
                this.data.wordChecks,
                this.data.docStatus,
                this.data.document,
                true
              );
            });
          } else {
            pt.parts.forEach((p) => {
              if (
                addPart(p, "childPartTypes", parent_dp_id, tp_id, saveOrder)
              ) {
                // p.expanded = true;
                found = true;
              }
            });
          }
        });
        return found;
      };
      let updPart = (parent, childProperty, dp_id) => {
        let found = false;
        parent[childProperty]?.forEach((pt) => {
          let targetPartIndex = pt.parts.findIndex(
            (p) => p.doc_part_id === dp_id
          );
          if (targetPartIndex >= 0) {
            pt.parts.splice(targetPartIndex, 1, request.part);
            parent.expanded = true;
            pt.parts.forEach((p) => {
              utils.setDocPartStatus(
                p,
                pt,
                this.data.wordChecks,
                this.data.docStatus,
                this.data.document,
                true
              );
            });
            found = true;
          } else {
            pt.parts.forEach((p) => {
              if (updPart(p, "childPartTypes", dp_id)) {
                parent.expanded = true;
                found = true;
              }
            });
          }
        });
        return found;
      };
      if (request.response) {
        if (request.response.result?.Data?.newRow) {
          request.part.doc_part_id = Number(
            request.response.result.Data.newRow.doc_part_id
          );
          if (request.response.result.Data.newRowAttributes?.length > 0) {
            request.part.attributes = request.part.attributes.map((ra) => {
              let match = request.response.result.Data.newRowAttributes.find(
                (x) => x.tpa_id === ra.tpa_id
              );
              return {
                ...ra,
                dpa_id: match?.dpa_id,
                text: match?.value || ra.text,
              };
            });
          }
          this.allSectionList.forEach((a) => {
            addPart(
              a,
              "part_data",
              request.part.parent_dp_id,
              request.part.tmpl_part_id,
              true
            );
            this.expandTarget(a.part_data, request.part.doc_part_id);
          });
          addPart(
            this.document,
            "parttypes",
            request.part.parent_dp_id,
            request.part.tmpl_part_id,
            false
          );
          this.expandTarget(this.document.parttypes, request.part.doc_part_id);
          // sectionParts is a deep-clone of the source data (built by
          // loadSectionContent via JSON.parse(JSON.stringify(...))) and
          // is what the rendered ViewParts iterates. Without this pass
          // a freshly-created part lands on the source trees but never
          // on the rendered tree, so newly-accepted suggestions for a
          // multi-row part stay invisible until the doc is closed and
          // re-opened (which re-clones from the now-updated source).
          // Pass `saveOrder=false` — the allSectionList pass above
          // already POSTed the order; passing true here would double
          // up the request.
          if (Array.isArray(this.sectionParts)) {
            addPart(
              { parttypes: this.sectionParts },
              "parttypes",
              request.part.parent_dp_id,
              request.part.tmpl_part_id,
              false
            );
            this.expandTarget(this.sectionParts, request.part.doc_part_id);
          }
        } else {
          this.allSectionList.forEach((a) =>
            updPart(a, "part_data", request.part.doc_part_id)
          );
          updPart(this.document, "parttypes", request.part.doc_part_id);
          // Mirror the splice into sectionParts (the rendered tree).
          // When findDocPartById returned the sectionParts copy this
          // is a same-ref splice and effectively a no-op, but it
          // keeps the contract symmetric — if a future caller passes
          // a part it found in the source tree, the rendered tree
          // still reflects the update.
          if (Array.isArray(this.sectionParts)) {
            updPart(
              { parttypes: this.sectionParts },
              "parttypes",
              request.part.doc_part_id
            );
          }
        }

        //do history
        if (request.response.result.Data.audit) {
          let idx = this.partsHistory.findIndex(
            (x) => x.key === request.response.result.Data.audit.key
          );
          if (idx >= 0) {
            this.partsHistory.splice(idx, 1);
          }
          this.partsHistory.push(request.response.result.Data.audit);
          if (this.history) {
            if (this.history.key === request.response.result.Data.audit.key) {
              this.history = {
                ...this.history,
                ...request.response.result.Data.audit,
              };
            }
          }
        }
        this.allHistory.push(request.response);
      }

      if (
        request.part &&
        request.partType?.tmpl_part_metadata?.linked_parts?.length > 0
      ) {
        this.togglePartDisplay(request.part, request.partType);
      }

      let target = this.activeSection.parent_section
        ? `${this.activeSection.parent_section ?? ""}|${
            this.activeSection.tmpl_view_section_id ?? ""
          }`
        : `${this.activeSection.tmpl_view_section_id ?? ""}|`;
      this.loadSectionContent(target);
      this.setCheckSummary();
    },
    insertPart(parent, part) {
      if (parent.parts.some((p) => p.doc_part_id === part.doc_part_id))
        return parent;

      if (part.insertOrder) parent.parts.splice(part.insertOrder, 0, part);
      else parent.parts.push(part);

      return parent;
    },
    saveStart() {
      this.saveInProgress = true;
    },
    saveEnd() {
      this.saveInProgress = false;
    },
    saveContentPart() {
      let isParent = this.editContentDialog.part.source;

      let partData = this.editContentDialog.part.part;

      let action =
        partData.tmpl_view_section_content_id &&
        partData.tmpl_view_section_part_id
          ? "UPDATE"
          : "INSERT";

      if (action === "INSERT") {
        let newObj = {
          ...this.editContentDialog.part.item,
          tmpl_part_metadata: {
            ...this.editContentDialog.part.item.tmpl_part_metadata,
            content_metadata: partData.content_metadata,
            content_name: partData.content_name,
            content_placeholder: partData.content_placeholder,
            content_text: partData.content_text,
            content_type: partData.content_type,
            layout: partData.layout,
            order: partData.order,
          },
        };

        if (isParent) {
          let parent = this.editPartDialog.data.find(
            (x) =>
              x.tmpl_part_id === this.editContentDialog.part.source.tmpl_part_id
          );
          newObj.tmpl_part_metadata.parent_id =
            this.editContentDialog.part.source.tmpl_view_section_part_id;
          parent.tmpl_part_metadata.linked_content.push(newObj);
        } else {
          this.editPartDialog.data.push(newObj);
        }
      } else {
        if (isParent) {
          let parent = this.editPartDialog.data.find(
            (x) =>
              x.tmpl_part_id === this.editContentDialog.part.source.tmpl_part_id
          );
          let source = parent.tmpl_part_metadata.linked_content.find(
            (x) =>
              x.tmpl_view_section_part_id === partData.tmpl_view_section_part_id
          );
          source.tmpl_part_metadata = {
            ...source.tmpl_part_metadata,
            ...partData,
          };
          source.parts[0].attributes[0] = {
            ...source.parts[0].attributes[0],
            ...partData,
          };
        } else {
          let source = this.editPartDialog.data.find(
            (x) =>
              x.tmpl_view_section_part_id === partData.tmpl_view_section_part_id
          );
          source.tmpl_part_metadata = {
            ...source.tmpl_part_metadata,
            ...partData,
          };
          source.parts[0].attributes[0] = {
            ...source.parts[0].attributes[0],
            ...partData,
          };
        }
      }

      this.editContentDialog.show = false;
    },
    updateModel(item) {
      this.editContentDialog.part = item;
    },
    editContentPart(item, parent) {
      item.parts[0].attributes[0] = {
        ...item.parts[0].attributes[0],
        layout: item.parts[0].attributes[0].layout.split("|") ?? [],
      };

      this.editContentDialog.part = {
        source: parent ? parent : null,
        item: item,
        part: item.parts[0].attributes[0],
        edit_type: "part",
        tmpl_part_id: null,
      };
      this.editContentDialog.show = true;
    },
    newContentPartObj(order) {
      let metadata = {
        order: order ?? 1,
        active: true,
        content_text: null,
        content_placeholder: null,
        content_metadata: null,
        tmpl_view_section_part_id: 0,
        tmpl_view_section_id: this.editPartDialog.section_id,
        contentPart: true,
        readonly: false,
        layout: [],
        linked_content: [],
        part_type: "contentPart",
      };

      let attr = {
        active: true,
        content_text: null,
        content_placeholder: null,
        content_metadata: null,
        content_type: "LABEL",
        doc_view_content_id: 0,
        layout: [],
        order: order ?? 1,
        parent_id: null,
        readonly: false,
        sequence: 1,
        tmpl_part_id: null,
        tmpl_view_id: this.currentView.tmpl_view_id,
        tmpl_view_section_content_id: 0,
        tmpl_view_section_id: this.editPartDialog.section_id,
        tmpl_view_section_part_id: 0,
        value: "",
      };

      let part = {
        attributes: [attr],
        linked_content: [],
        notes: "",
        sequence: 1,
        text: "",
      };

      let partItem = {
        childPartTypes: [],
        parts: [part],
        permissions_list: {
          editPermissionOverride: null,
          viewPermissionOverride: null,
          restrictSection: false,
          permissions: [],
          hierarchyPermissions: [],
          permissionControlled: false,
          hrPermissionControlled: false,
        },
        positionRow: 1,
        tmpl_part_id: null,
        tmpl_part_metadata: metadata,
        tmpl_view_section_part_id: 0,
        type: "",
        visible: true,
        requireInit: true,
      };

      return partItem;
    },
    addPartGroup(item) {
      console.log(item);
    },
    editContentGroup(item) {
      console.log(item);
      this.editPartDialog.editMode = "group";
    },
    addContentPart(item) {
      let position = item
        ? item.tmpl_part_metadata.linked_content.length + 1
        : this.editPartDialog.data.length + 1;

      let newContentPart = this.newContentPartObj(position);

      this.editContentDialog.part = {
        source: item ? item : null,
        item: newContentPart,
        part: newContentPart.parts[0].attributes[0],
        edit_type: "part",
        tmpl_part_id: null,
      };
      this.editContentDialog.show = true;
    },
    addPartToSection(item) {
      let items = this.editPartDialog.data.map((x) => x.order);
      let order = items.length > 0 ? Math.max.apply(null, items) : 0;
      let flatParts = viewUtils.genericFlatten(
        this.document.parttypes,
        "childPartTypes"
      );
      let sourcePart = flatParts.find((p) => p.tmpl_part_id === item.tp_id);

      sourcePart.tmpl_part_metadata = {
        ...sourcePart.tmpl_part_metadata,
        order: order,
        linked_content: [],
        active: true,
        part_type: "docPart",
      };

      sourcePart = {
        ...sourcePart,
        permissions_list: {
          editPermissionOverride: null,
          viewPermissionOverride: null,
          displayPermissionOverride: null,
          restrictSection: false,
          permissions: [],
          hierarchyPermissions: [],
          permissionControlled: false,
          hrPermissionControlled: false,
          view_dependencies: [],
        },
        order: order + 1,
        active: true,
        requireInit: true,
        tmpl_view_section_part_id: 0,
        tmpl_view_section_id: this.editPartDialog.section_id,
      };
      this.editPartDialog.data.push(sourcePart);
      let avail = this.editPartDialog.available.find(
        (x) => x.tp_id === item.tp_id
      );
      avail.exists = true;
    },
    async saveSection(id) {
      this.saveStart();
      let flattened = this.getFlatSections();
      let targetSection = flattened.find((x) => x.tmpl_view_section_id === id);
      await viewUtils.docViewSaveSection(targetSection).then(() => {
        this.triggerNotification("Section Updated Succesfully", "success");
        this.saveEnd();
      });
    },
    async saveSectionParts() {
      this.saveStart();
      let flattened = this.getFlatSections();
      let targetSection = flattened.find(
        (x) => x.tmpl_view_section_id === this.editPartDialog.section_id
      );
      targetSection.part_data = this.editPartDialog.data;
      this.editPartDialog.show = false;
      let target = targetSection.parent_section
        ? `${targetSection.parent_section ?? ""}|${
            targetSection.tmpl_view_section_id ?? ""
          }`
        : `${targetSection.tmpl_view_section_id ?? ""}|`;
      await viewUtils
        .docViewSaveSectionParts(targetSection.part_data)
        .then((resp) => {
          targetSection.part_data = resp.data;
          this.loadSectionContent(target);
          this.triggerNotification(
            "Section Parts Updated Succesfully",
            "success"
          );
          this.saveEnd();
        });
    },
    removePartFromSection(item) {
      console.log(item);
    },
    onChange() {
      this.reorder();
    },
    reorder() {
      this.editPartDialog.data.forEach(
        (item, index) => (item.tmpl_part_metadata.order = index + 1)
      );
    },
    removeRelatedAt(subIdx, idx) {
      let child =
        this.editPartDialog.data[idx].tmpl_part_metadata.linked_content[subIdx];
      child.toDelete = true;
      this.editPartDialog.data = JSON.parse(
        JSON.stringify(this.editPartDialog.data)
      );
    },
    removeAt(idx) {
      let item = this.editPartDialog.data[idx];
      item.toDelete = true;
      if (item.tmpl_part_metadata.linked_content.length > 0) {
        item.tmpl_part_metadata.linked_content.forEach((s) => {
          s.toDelete = true;
        });
      }
    },
    getFlatSections() {
      const getFlat = (data) =>
        data.map((d) => [d, ...getFlat(d.sub_sections)]).flat();
      let flattened = getFlat(this.currentView.sections);
      return flattened.filter(
        (x) =>
          x.permissions_list.displayPermissionOverride === null ||
          x.permissions_list.displayPermissionOverride === true
      );
    },
    loadPartsForSection(id) {
      let flattened = this.getFlatSections();
      let targetSection = flattened.find((x) => x.tmpl_view_section_id === id);
      this.editPartDialog.available = this.templateDefinition.parts
        .filter((x) => x.tp_active && x.parent_tp_id === null)
        .map((p) => {
          let match = targetSection.part_data.find(
            (sp) => sp.tmpl_part_id === p.tp_id
          );
          return {
            ...p,
            ...match,
            exists: match ? true : false,
          };
        });

      let parts = targetSection.part_data.map((p) => {
        let match = this.templateDefinition.parts.find(
          (sp) => sp.tp_id === p.tmpl_part_id
        );
        return {
          ...p,
          data: match ?? {
            tp_name: p.content_name,
          },
          toDelete: false,
        };
      });
      this.editPartDialog.section_id = id;
      this.editPartDialog.data = parts;
      this.reorder();
      this.editPartDialog.show = true;
    },
    getSectionFromID(id) {
      let currentSection = id.split("|");
      let targetSection = this.currentView.sections.find(
        (x) => x.tmpl_view_section_id === Number(currentSection[0])
      );
      if (currentSection[1]) {
        targetSection = targetSection.sub_sections.find(
          (x) => x.tmpl_view_section_id === Number(currentSection[1])
        );
      }

      return targetSection;
    },
    async saveSectionContent(saveReq) {
      await viewUtils.auditSectionChange(saveReq).then((resp) => {
        console.log(resp);
      });
    },
    async navSections(dir) {
      let current = `${this.currentViewSectionId ?? ""}|${
        this.currentViewSubSectionId === 0 ? "" : this.currentViewSubSectionId
      }`;
      let nav = this.currentView.navigationPath.indexOf(current);
      let nextIdx = 0;
      switch (dir) {
        case "Next":
          nextIdx = nav + 1;
          break;
        case "Complete":
          nextIdx = nav + 1;
          break;
        case "Back":
          nextIdx = nav - 1;
          break;
        case "CompleteAll":
          {
            let allSecs = [];
            let currentSection = this.allSectionList.find(
              (x) => x.tmpl_view_section_id === this.currentViewSectionId
            );
            let currentIdx = this.allSectionList.indexOf(currentSection);
            let target = this.allSectionList.find(
              (x) =>
                x.tmpl_view_section_id ===
                currentSection.complete_all_target_section_id
            );
            let targetIdx = this.allSectionList.indexOf(target);
            for (let i = currentIdx; i < targetIdx; i++) {
              let sec = this.allSectionList[i];
              if (!sec.complete) {
                sec.complete = true;
                allSecs.push({
                  doc_id: this.data.document.doc_id,
                  tmpl_view_section_id: sec.tmpl_view_section_id,
                  audit_data: {
                    complete: sec.complete,
                  },
                });
              }
              nextIdx = i;
            }

            this.saveStart();
            await Promise.all(
              allSecs.map(async (update) => {
                await this.saveSectionContent(update);
              })
            ).then((resps) => {
              this.saveEnd(resps);
            });

            nextIdx = nextIdx + 1;
          }
          break;
      }

      if (nav === 0) {
        let targetSection = this.getSectionFromID(current);
        if (!targetSection.complete) {
          targetSection.complete = true;

          this.saveStart();
          await this.saveSectionContent({
            doc_id: this.data.document.doc_id,
            tmpl_view_section_id: targetSection.tmpl_view_section_id,
            audit_data: {
              complete: targetSection.complete,
            },
          }).then((resp) => {
            this.saveEnd(resp);
          });
        }
      }

      if (dir === "Complete") {
        let targetSection = this.getSectionFromID(current);
        if (!targetSection.complete) {
          targetSection.complete = true;

          this.saveStart();
          await this.saveSectionContent({
            doc_id: this.data.document.doc_id,
            tmpl_view_section_id: targetSection.tmpl_view_section_id,
            audit_data: {
              complete: targetSection.complete,
            },
          }).then((resp) => {
            this.saveEnd(resp);
          });
        }
      }

      let next = this.currentView.navigationPath[nextIdx];
      let parts = next.split("|");
      this.$refs["viewDisplay"].activateSection(parts[0], parts[1]);
    },
    addSubSection(parentId) {
      this.$emit("addSubSection", parentId);
    },
    changePanel(val) {
      this.rightPanel = val;
    },
    editPart(item, part) {
      if (this.admin) {
        this.$nextTick(() => {
          this.editingSection = {
            item: { ...item },
            part: { ...part },
            edit_type: "part",
          };
          this.editingSection = JSON.parse(JSON.stringify(this.editingSection));
          this.rightPanel = "permissions";
          this.rightPanelHeader = `Editing Part: ${item.type}`;
        });
      }
    },
    editPartPermission(item, part) {
      if (this.admin) {
        this.rightPanel = "permissions";
        this.$nextTick(() => {
          this.editingSection = {
            item: { ...item },
            part: { ...part },
            tmpl_id: this.document.doc_view_config.tmpl_id,
            edit_type: "partPermissions",
            sectionId:
              this.currentViewSubSectionId > 0
                ? this.currentViewSubSectionId
                : this.currentViewSectionId,
          };
        });
      }
    },
    addSection() {
      this.$emit("addSection");
    },
    editSectionOrder() {
      this.$emit("editSectionOrder");
    },
    editSectionDefinition(target) {
      if (this.admin) {
        this.$emit("editSection", target);
        let targetSection = this.getSectionFromID(target);
        this.rightPanelHeader = `Editing Section: ${targetSection.section}`;
        this.$nextTick(() => {
          this.editingSection = {
            item: targetSection,
            edit_type: "section",
            tmpl_id: this.document.doc_view_config.tmpl_id,
          };
          this.rightPanel = "permissions";
        });
      }
    },
    editPermissions(target) {
      if (this.admin) {
        this.rightPanel = "permissions";
        this.$nextTick(() => {
          let targetSection = this.getSectionFromID(target);
          this.editingSection = {
            item: targetSection,
            edit_type: "sectionPermissions",
            tmpl_id: this.document.doc_view_config.tmpl_id,
          };
        });
      }
    },
    init() {
      if (this.data && this.data?.document) {
        this.document = this.data.document ?? null;
        this.docStatus = this.data.docStatus ?? null;
        this.docHierarchies = this.data.docHierarchies ?? null;
        this.partsHistory = this.data.partsHistory ?? null;
        this.wordChecks = this.data.wordChecks ?? null;
        this.templateDefinition = this.data.template ?? null;
        this.currentView = this.data.document.doc_view_config;
        this.allSectionList = viewUtils.getFlatSections(
          this.currentView.sections
        );
        this.loadSectionContent(this.currentView.navigationPath[0]);
        this.initCheckSummary();
        this.collaboration =
          this.data.document.state.show_collaboration &&
          this.data.document.state.canEditDocParts;
        this.isLoading = false;
        this.loadSettings();
        if (
          this.$vuetify.breakpoint.smAndDown ||
          (!this.showScoring && !this.data.document.state.canEditDocParts)
        ) {
          this.toggleRHS("hidden");
        } else if (this.data.sourceFile) {
          this.sourceFile = this.data.sourceFile;
          if (this.rhDefaultShow)
            this.toggleRHS("database");
        }
        this.docMatches.data = this.document?.matches ?? [];
        if(this.data.document.prompt_chain){
          let data = {
            doc_id: this.data.document.doc_id,
            hr_ids: this.data.document.hierarchies.map(x => x.hr_id),
            active_generation: this.data.document.active_generation
          }

          this.generateContentData = {
            doc: data,
            prompt_chain: this.data.document.prompt_chain
          }

          if (this.data.document.active_generation) {
            this.generateContentDialog.status = 'processing';
              if(this.isNew){
                this.$nextTick(() => {
                  this.generateContentDialog.show = true;
                  this.$nextTick(() => {
                    if (this.$refs.generateContentRef) {
                      if (this.$refs.generateContentRef.resumeActiveGeneration) {
                        this.$refs.generateContentRef.resumeActiveGeneration(
                          this.data.document.active_generation
                        );
                      } else if (this.$refs.generateContentRef.activate) {
                        this.$refs.generateContentRef.activate();
                      }
                    }
                  });
                });
              }  else {
                this.toggleRHS('contentGen')
              }          

          }
        }
      }
    },
    loadSettings() {
      let languageOpts = nlpUtils.getLanguageTools(this.$loginState.user);
      this.userSpellCheckEnabled = languageOpts?.spellCheck?.enabled;
      this.spellCheckOnLoad =
        this.userSpellCheckEnabled &&
        languageOpts?.spellCheck?.options?.checkOnLoad &&
        !this.isTranslated;
    },
    flattenArray() {
      const getFlat = (data) =>
        data.map((d) => [d, ...getFlat(d.sub_sections)]).flat();
      let flattened = getFlat(this.currentView.sections);
      let filteredList = flattened.filter(
        (x) =>
          x.view_mode === "DATACAPTURE" ||
          (x.part_data.length > 0 &&
            x.tmpl_view_section_id !== this.activeSection.tmpl_view_section_id)
      );
      let processedList = filteredList.map((p) => {
        return {
          ...p,
          part_data: this.processPartList(p.part_data),
        };
      });
      this.$nextTick(() => {
        this.currentReviewSection = processedList.map((object) => ({
          ...object,
        }));
      });
    },
    loadSectionDetails(targetSection) {
      this.bannerText = targetSection.header_type ?? "";
      this.footerText = targetSection.footer_type ?? "";

      this.displayHeader = this.bannerText !== "";

      let current = `${this.currentViewSectionId ?? ""}|${
        this.currentViewSubSectionId === 0 ? "" : this.currentViewSubSectionId
      }`;
      this.navBackDisabled = false;
      this.navNextDisabled = false;

      let navIdx = this.currentView.navigationPath.findIndex(
        (x) => x === current
      );

      this.navBackDisabled = false;
      this.navNextDisabled = false;
      this.navBackHide = false;
      this.navNextHide = false;
      this.navChangesHide = targetSection.show_changes ? false : true;

      if (!this.admin) {
        this.show_lhs_expand = targetSection.lhs_expandable === 1;
        this.show_rhs_expand = targetSection.rhs_expandable === 1;

        this.lhDrawer.defaultShow = targetSection.lhs_expanded === 1;
        this.rhDefaultShow = targetSection.rhs_expanded === 1 && !this.isTranslated;
        this.rightPanel = this.rhDefaultShow ? 'score' : 'hidden';
        this.autoCollapseSidePanels(true);
      }

      this.displayLHS = true;
      this.displayRHS = true;

      if (navIdx >= this.currentView.navigationPath.length - 1) {
        navIdx = this.currentView.navigationPath.length - 1;
      }
      if (navIdx === this.currentView.navigationPath.length - 1) {
        this.navNextDisabled = true;
        this.navNextHide = true;
        this.navChangesHide = true;
      }
      if (navIdx === 0) {
        this.navBackDisabled = true;
        this.navBackHide = true;
      }

      if (targetSection.sub_sections.length > 0) {
        this.navChangesHide = true;
      }

      this.sectionCompleteSub = targetSection.enable_complete_subsections;
      this.sectionCompleteLabel = targetSection.complete_all_label;
      this.sectionUnusedParts = targetSection.part_data_unused;

      this.displayLinkedContent =
        targetSection.sub_sections.length > 0
          ? targetSection.view_linked_content
          : true;

      if (this.activeSection.view_mode === "REVIEW") {
        this.flattenArray();
        if (
          this.activeSection.submit_action_id &&
          this.activeSection.submit_action_id > 0
        ) {
          this.submitAction = this.data.document.state.actionsAvailable.find(
            (x) => x.lifecycle_action_id === this.activeSection.submit_action_id
          );
        }
      }
    },
    applyPartUpdate(data) {
      let idx = this.sectionParts.findIndex(
        (x) =>
          x.tmpl_view_section_part_id === data.item.tmpl_view_section_part_id
      );
      if (idx > -1) {
        this.sectionParts[idx] = data.part;
        this.updateList();
      }
    },
    cancelEditUpdate(data) {
      if (data.edit_type === "section") {
        if (
          data.item.tmpl_view_section_id ===
          (data.item.parent_section
            ? this.currentViewSubSectionId
            : this.currentViewSectionId)
        ) {
          this.loadSectionDetails(data);
        }
      } else if (data.edit_type === "part") {
        this.applyPartUpdate(data);
      }
      this.editingSection = null;
      this.rightPanel = "score";
    },
    applySectionUpdate(data) {
      if (data.edit_type === "section") {
        if (
          data.item.tmpl_view_section_id ===
          (data.item.parent_section
            ? this.currentViewSubSectionId
            : this.currentViewSectionId)
        ) {
          let target = data.item.parent_section
            ? `${data.item.parent_section ?? ""}|${
                data.item.tmpl_view_section_id ?? ""
              }`
            : `${data.item.tmpl_view_section_id ?? ""}|`;
          this.loadSectionContent(target);
        }
      } else if (data.edit_type === "part") {
        this.applyPartUpdate(data);
      }
    },
    processPartList(partList) {
      return partList.map((object) => ({ ...object }));
    },
    loadSectionContent(section) {
      if (!section) return;
      var sections = section.split("|").filter((x) => x !== "" && x !== null);
      if (sections.length > 0) {
        let targetSection = this.currentView.sections.find(
          (x) => x.tmpl_view_section_id === Number(sections[0])
        );
        let newPartList = [];
        this.currentViewSubSectionId = 0;
        this.currentViewSectionId = Number(sections[0]);
        this.sectionParts = JSON.parse(JSON.stringify(newPartList));
        if (sections[1]) {
          targetSection = targetSection.sub_sections.find(
            (x) => x.tmpl_view_section_id === Number(sections[1])
          );
          this.currentViewSubSectionId = Number(sections[1]);
          newPartList = targetSection.part_data;
        } else {
          let viewLinked = targetSection.view_linked_content;
          let sectionList = [
            targetSection.part_data,
            targetSection.sub_sections
              .filter(
                (x) =>
                  x.permissions_list.displayPermissionOverride === null ||
                  x.permissions_list.displayPermissionOverride === true
              )
              .map((x) => {
                return viewLinked
                  ? x.part_data
                  : x.part_data.filter((x) => x.tmpl_part_id);
              })
              .flat(1),
          ].flat(1);

          let idx = 1;
          sectionList.forEach((x) => {
            newPartList.push({
              ...x,
              order: idx,
            });
            idx++;
          });
        }

        this.sectionParts = null;
        this.sectionParts = JSON.parse(
          JSON.stringify(this.processPartList(newPartList))
        );

        if (
          this.activeSection === null ||
          this.activeSection.tmpl_view_section_id !==
            targetSection.tmpl_view_section_id
        ) {
          this.activeSection = targetSection;
          this.loadSectionDetails(targetSection);

          this.toggleRHS(this.rightPanel);
          if (this.admin && this.rightPanel === "permissions") {
            this.editSectionDefinition(section);
          }
        }
        this.updateList();
        this.expandAllPartTypes();
      }
    },
    getWordChecksForPart(tpid, checks, hchys) {
      let tempChecks = checks.map((object) => ({ ...object }));
      let filtered = tempChecks.filter((w) =>
        w.tmpl_part_types.some(
          (tp) =>
            tp.tp_id === tpid &&
            (!tp.exclusions.length ||
              !hchys.some((h) =>
                tp.exclusions.some((e) => e.hr_id === h.hr_id)
              ))
        )
      );
      return utils.initialisePartChecks(filtered);
    },
    updateList() {
      this.$nextTick(() => {
        this.sectionParts = this.sectionParts.map((object) => ({ ...object }));
      });
    },
    refreshDocMatches() {
      if (this.activeSection && !this.activeSection.show_similar)
        return;

      if (!this.editInProgress) {
        if (this.docMatches.data && this.document.matches && this.docMatches.data.length !== this.document.matches.length && this.showSimilaritiesPanel) {
          this.docMatches.highlight = true;
          this.docMatches.blinking = true;
          setTimeout(() => this.docMatches.blinking = false, 5000);
        }
        this.docMatches.data = this.document.matches;
      }
    },
    saveDataCapture(def, action) {
      this.$emit("saveDataCapture", def, action);
    },
    commentResolved(data) {
      let part = viewUtils.findPart(this.data.document.parttypes, data.dp_id);
      if (part) {
        if (!data.document_comment_id) {
          part.comments_unresolved = data.resolved ? 0 : part.comments_total;
        } else {
          part.comments_unresolved += data.resolved ? -1 : 1;
        }
        if (part.comments_unresolved < 0) part.comments_unresolved = 0;
        this.partCommentUpdate = { 
          dp_id: part.dp_id,
          comments_unresolved: part.comments_unresolved,
          comments_total: part.comments_total,
          hasComments: part.hasComments,
        };
      }
    },
    commentSaved(data) {
      let part = viewUtils.findPart(this.data.document.parttypes, data.dp_id);
      if (part) {
        part.comments_unresolved = 0;
        part.comments_total = 0;
        part.hasComments = 0;
        data.comments.forEach(c => {
          part.comments_total++;
          part.hasComments = 1;
          if (c.resolved === 0) part.comments_unresolved++;
        });
        this.partCommentUpdate = { 
          dp_id: part.dp_id,
          comments_unresolved: part.comments_unresolved,
          comments_total: part.comments_total,
          hasComments: part.hasComments,
        };
      }      
    },
    expandAllPartTypes() {
      this.sectionParts.forEach(x => this.expandTargetPartType(x, true));
    },
    expandChildren(tmpl_part_id) {
      let pt = this.sectionParts.find(x => x.tmpl_part_id === tmpl_part_id);
      if (pt) {
        this.expandTargetPartType(pt, true);
      }      
    },
    collapseChildren(tmpl_part_id) {
      let pt = this.sectionParts.find(x => x.tmpl_part_id === tmpl_part_id);
      if (pt) {
        this.expandTargetPartType(pt, false);
      }      
    },
    expandTargetPartType(partType, value) {
      partType.parts.forEach(p => {
        if (p.childPartTypes?.length) {
          p.expanded = value;
          p.childPartTypes.forEach(cpt => {
            this.expandTargetPartType(cpt, value);
          });
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
/*
 * Anchor for the inline Atlas panel. AtlasFlyout in `inline` mode uses
 * `position: absolute; inset: 0`, so its host needs a bounded relative
 * box. Relies on `.rightHolderContentMain` declaring `height: 100%`
 * (added alongside its existing max-height) so the chain of 100%
 * heights resolves all the way up to .rightHolderContent's explicit
 * viewport-based height.
 */
.atlas-tab-host {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.dragHandle {
  font-size: 12px !important;
  display: inline-flex;
  padding-right: 10px;
  cursor: move;
  top: 3px;
  align-items: flex-start !important;
}

.dataTableView:nth-child(even) {
  background: #f5f5f5;
}

.dataTableView:nth-child(odd) {
  background: #fff;
}

.docBanner {
  text-align: center;
  width: 100%;
  height: 36px;
  color: #ffffff;
  background: #54616c;
  border-radius: 4px;
  margin-top: 5px;
  padding-top: 8px;
  padding-right: 50px;
}

.docViewHolder {
  $actionHeaderHeight: 0px;
  $bannerTopOffset: calc(
    #{var(--header-height)} + #{var(--doc-banner-height)} + #{$actionHeaderHeight}
  );
  $headerHeight: var(--header-height);
  $mainPanelHeight: calc(
    100vh - #{var(--container-height)} - #{var(--container-top-offset)}
  );
  $childPanelHeight: calc(
    100vh - #{var(--header-height)} - #{var(--container-top-offset)}
  );
  $docContentHeight: calc(
    100vh - #{var(--header-height)} - #{var(--doc-banner-height)} - #{var(
        --doc-footer-height
      )} - #{var(--container-top-offset)} - #{$actionHeaderHeight}
  );

  width: 100%;
  max-width: 100%;
  height: $mainPanelHeight;
  max-height: $mainPanelHeight;
  overflow-x: hidden;
  overflow-y: auto;
  /* padding-top: var(--display-mode-topPadding); */
  position: relative;
  top: var(--display-mode-topPadding);

  $scrollbarOffset: 0px;

  .docSectionHolderLeftActionsTemp {
    position: absolute; left: 10px; top: 10px;
  }

  .docSectionHolderLeft {
    width: var(--left-panel-width) !important;
    height: $childPanelHeight;
    max-height: $childPanelHeight;
    overflow-y: hidden;
    position: absolute;

    .docSectionHolderLeftActions {
      position: absolute; right: 5px; top: 10px;
    } 
  }

  .docHolder {
    height: $childPanelHeight;
    max-height: $childPanelHeight;
    width: calc(
      100% - #{var(--left-panel-space)} - #{var(--right-panel-width)} - #{$scrollbarOffset}
    );

    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
      0 1px 5px 0 rgb(0 0 0 / 12%);
    padding: 0px 0px 0px 5px;
    left: var(--left-panel-space);
    right: var(--right-panel-width);
    position: absolute;

    $contentWidth: calc(
      #{var(--content-width)} - #{var(--left-panel-space)} - #{var(
          --right-panel-width
        )} - #{$scrollbarOffset} - 5px
    );

    .docHolderActionsHeader {
      //position: fixed;
      float: right;
      height: $actionHeaderHeight;
      width: $contentWidth;
      z-index: 1;
      overflow: hidden;
      padding-right: 15px;
    }

    .docHolderTop {
      position: fixed;
      height: var(--doc-banner-height);
      width: $contentWidth;
      z-index: 1;
      overflow: hidden;
      padding-right: 15px;
      top: $bannerTopOffset;
    }
    .docHolderCenter {
      min-width: $contentWidth;
      overflow-y: scroll;
      overflow-x: scroll;
      height: $docContentHeight;
      max-height: $docContentHeight;
      position: relative;
      top: calc(#{var(--doc-banner-height)} + #{$actionHeaderHeight});
      &::-webkit-scrollbar-track {
        background: transparent;
      }
    }
    .docHolderFooter {
      width: $contentWidth;
      overflow-y: scroll;
      height: var(--doc-footer-height);
      max-height: var(--doc-footer-height);
      position: fixed;
      bottom: 0px;
      overflow: hidden;
      padding-right: 15px;
      padding-top: 5px;
      display: inline-flex;

      .content-gen-btn.content-gen-complete {
        position: relative;
        overflow: visible;
        border: 1px solid transparent !important;
        background-clip: padding-box;
        animation: pulse-shadow 5s ease-in-out infinite;

        &::before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          right: -1px;
          bottom: -1px;
          border-radius: inherit;
          background: linear-gradient(90deg, #9c27b0, #e91e63, #2196f3, #9c27b0);
          background-size: 300% 100%;
          animation: gradient-move 3s linear infinite;
          z-index: -1;
        }

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: inherit;
          background: white;
          z-index: -1;
        }
      }
    }
  }

  @keyframes gradient-move {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 300% 50%;
    }
  }

  @keyframes pulse-shadow {
    0%, 100% {
      box-shadow: 0 0 4px rgba(156, 39, 176, 0.25),
                  0 0 8px rgba(233, 30, 99, 0.15),
                  0 0 12px rgba(33, 150, 243, 0.08);
    }
    50% {
      box-shadow: 0 0 6px rgba(156, 39, 176, 0.35),
                  0 0 12px rgba(233, 30, 99, 0.25),
                  0 0 18px rgba(33, 150, 243, 0.12);
    }
  }

  @keyframes text-glow {
    0%, 100% {
      text-shadow: 0 0 8px rgba(76, 175, 80, 0.4),
                   0 0 12px rgba(76, 175, 80, 0.2);
      color: #4caf50;
    }
    50% {
      text-shadow: 0 0 12px rgba(76, 175, 80, 0.6),
                   0 0 20px rgba(76, 175, 80, 0.3);
      color: #66bb6a;
    }
  }

  @keyframes icon-pulse {
    0%, 100% {
      transform: scale(1);
      filter: drop-shadow(0 0 3px rgba(76, 175, 80, 0.6));
    }
    50% {
      transform: scale(1.15);
      filter: drop-shadow(0 0 6px rgba(76, 175, 80, 0.8))
              drop-shadow(0 0 10px rgba(76, 175, 80, 0.4));
    }
  }

  .docSectionHolderRight {
    width: var(--right-panel-width);
    height: $childPanelHeight;
    max-height: $childPanelHeight;
    border-left: 1px solid #e3e3e7;
    right: 0;
    float: right;
    transition: width 200ms;
    padding: 5px 0px 15px 0px;
    position: relative;

    .rightHolderNavActions {
      width: 30px;
      display: inline-flex;
      float: left;
      top: 32px;
      position: absolute;
      padding: 7px 3px 7px 5px;
      border-radius: 20px 0 0 20px;
      left: -30px;
      border-top: 1px solid #D2D2D2;
      border-bottom: 1px solid #D2D2D2;
      border-left: 1px solid #D2D2D2;
      cursor: pointer;
    }

    .rightHolderNav {
      width: 100%;
      max-width: 100%;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #e3e3e7;
    }

    .rightHolderContent {
      height: calc(100vh - 158px);
      padding: 0 2px 3px 0px;
      top: 0px;
      position: relative;

      .rightHolderContentLabel {
        height: 30px;
        text-align: center;
        display: flex;
        justify-content: space-between;;
        padding: 10px 20px;
      }

      .rightHolderContentMain {
        height: 100%;
        max-height: calc(100vh - 150px - #{var(--container-height)});
        padding-right: 0;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }
}

.v-application.theme--light .docViewHolder {
  background-color: #ffffff;
}

table {
  border: 1px solid #ccc;
}
table td {
  padding: 15px;
  border: 1px solid #3a3838;
}
table td.selected {
  background-color: #aea8ff;
}

.v-btn.sectionItem {
  border: 0;
}

.scorePanel {
  padding-bottom: 10px;
  width: 100%;
  height: 100%;
  max-height: 100%;

  .scorecard {
    font-size: 16px;
    border-radius: 15px;
    margin: 0 10px;
    padding: 5px;

    .inclusionHeading {
      padding-left: 5px;
      word-break: break-word;
      width: 300px;
    }
  }

  .scoreValue {
    font-size: 12px;
  }

  .scoreDetail {
    display: flex;
    align-items: center;
    justify-content: start;
  }

  .errorCount {
    margin-top: -12px;
    margin-left: -5px;
    font-size: 9px;
    text-transform: none;
    width: 8px;
  }

  ::v-deep {
    .v-expansion-panel {
      .sectionText, .scoreDetail {
        padding-left: 25px;
        width: 100%;
      }
      .v-expansion-panel-header__icon {
        position: absolute;
        left: 0;
      }
      .v-expansion-panel-content__wrap {
        padding-left: 25px
      }
    }
    .v-expansion-panel--active>.v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
      transform: rotate(-90deg);
    }
    .v-card__subtitle, .v-card__text {
      font-size: 16px;
    }
    .v-badge__badge {
      color: #000;
    }
  }
}

.v-application.theme--light {  
  .scorePanel {
    background-color: #F7F9FB;
    color: #000000;
  }
  .scoreValue {
      color: #000;
    }
  .scorePanel, .scorePanel .doc-view-font {
    color: #000000 !important;
  }
  .rhsExpansionHeader {
    .v-chip {
      background-color: #fff;
    }
  }
  .rightHolderNavActions {
    background-color: #eee;
  }
}

.v-application.theme--dark {
  .scoreValue {
    color: #fff;
  }
  .scorePanel, .scorePanel .doc-view-font {
    color: #fff !important;
  }
  .rightHolderNavActions {
    background-color: #313131;
  }
}

.rhsExpansionHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 48px; 
  cursor:pointer; 
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.6px;
  letter-spacing: 0.5px;
  text-align: left;
  padding: 10px;
  margin-bottom: 5px;
}

.blinking {
  animation: blinker 1s linear infinite;
}

::v-deep .rightHolderTabs {
  .v-tabs-slider-wrapper {
    height: 4px !important;
  }
  .v-tab {
    text-transform: none;
    padding: 0 5px;
  }
  .v-tab--active {
    font-weight: 600;
  }
  .v-slide-group__prev, .v-slide-group__next {
    .v-icon.v-icon {
      font-size: 24px;
    }
    flex: 0 1 26px;
    min-width: 26px;
  }

  // Glowing text effect for completed content generation
  .v-tab.content-gen-complete {
    .content-gen-text {
      animation: text-glow 2s ease-in-out infinite;
      font-weight: 600;
    }

    .content-gen-check-icon {
      animation: icon-pulse 2s ease-in-out infinite;
      font-size: 20px !important;
      filter: drop-shadow(0 0 3px rgba(76, 175, 80, 0.6));
    }
  }
}

.v-application.theme--light .rightHolderTabs::v-deep {
  .v-tab--active {
    color: #000;
  }
}
.v-application.theme--dark .rightHolderTabs::v-deep {
  .v-tab--active {
    color: #fff;
  }
}

@keyframes blinker {
  50% {
    opacity: 20%;
  }
}



.beta-label {
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-style:italic;
  width: 75px;
  display: flex;
  justify-content: center; 
  margin: 0px 8px;   

  span {
    padding-top:2px
  }
}

/* Optional: Add animation */
.beta-label.pulse {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
</style>
